<template>
  <Loader v-if="loader" />
  <ConfirmDialog group="agente-otp" />

  <SupplyRiepilogoSection
    v-if="data.item.id || route.params?.id"
    entity-type="agente"
    :cliente-id="data.item.id || route.params?.id"
    :cliente-nome="data.item.info?.name"
    :saldo-residuo="fattureAperte ? Number(fattureAperte.totale_scoperto) || 0 : 0"
    :pratiche-data="{ pratiche: [], pratiche_gestione: [] }"
  />

  <Accordion :lazy="true" :activeIndex="[0]" multiple>
    <AccordionTab>
      <template #header>
        <span>Andamento {{ data.item.info.name }}</span>
        <impersonate-button
          v-if="data.item.id"
          class="ml-auto"
          target-type="agent"
          :target-id="data.item.id"
          :emails="data.item.info.email ? [data.item.info.email] : []"
          :name="data.item.info.name"
        />
      </template>
      <div class="w-full p-3" v-if="loadingAndamento">
        <Skeleton class="mb-2"></Skeleton>
        <Skeleton width="10rem" class="mb-2"></Skeleton>
        <Skeleton width="5rem" class="mb-2"></Skeleton>
        <Skeleton height="2rem" class="mb-2"></Skeleton>
        <Skeleton width="10rem" height="4rem"></Skeleton>
      </div>
      <div v-else-if="loadedAndamento">
        <div class="flex">
          <div :class="[`card col-6`]" v-for="(type_pp, index) in data.item.report_forniture" :key="type_pp">
            <div style="height: 100%; width: 100%;" :class="[`flex ${types_pp.find(type => type.prop == index).img}`]"
              :style="Object.keys(data.item.report_forniture).length > 1 && index == 'ee' ? 'background-position: right' : 'background-position: left'">
            </div>
            <div v-for="(item, name_item) in type_pp" :key="item" style="position: relative; top:-100%"
              :class="['flex align-items-center', { 'flex-row-reverse': Object.keys(data.item.report_forniture).length > 1 && index == 'gas' }]">
              <p
                :class="['font-description text-primary p-0 m-0 col-3 flex', { 'justify-content-end': Object.keys(data.item.report_forniture).length > 1 && index == 'gas', 'font-description-large': name_item == 'rendimento' }]">
                {{types_state.find(type => type.prop == name_item).description}}</p>
              <div
                :class="['flex col-6 justify-content-between', { 'flex-row-reverse': Object.keys(data.item.report_forniture).length > 1 && index == 'gas' }]">
                <p class="p-0 m-0 font-unita">
                  <span class="font-device">{{ item.pp }}</span> {{types_pp.find(type => type.prop == index).device}}
                </p>
                <p class="p-0 m-0 font-unita">
                  {{ !item.q || index == 'gas' ? item.q.toFixed(2) : item.q.toFixed(5) }} {{types_pp.find(type =>
                    type.prop == index).unit}}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <Chart type="bar" :data="chartData" :options="chartOptions" class="h-30rem" />
        </div>
      </div>
    </AccordionTab>
    <AccordionTab header="Anagrafica">
      <div v-if="data.item.id">
        <div class="formgrid grid">
          <div class="field col-12 md:col-6">
            <label for="name">Nome</label>
            <prime-input-text id="name" v-model="data.item.info.name" type="text" :disabled="!isInEdit"
              class="inputfield w-full" />
          </div>
          <div class="field col-12 md:col-6">
            <label for="email">Email</label>
            <prime-input-text id="email" v-model="data.item.info.email" type="text" :disabled="!isInEdit"
              class="inputfield w-full" @update:modelValue="removeErrors('email')" />
            <small class="p-error" v-if="validationErrors.isEmail">Formato non valido</small>
            <small class="p-error" v-if="validationErrors.existEmail">Email già presente</small>
          </div>

          <div class="field col-12 md:col-6">
            <label for="telefono">Telefono</label>
            <prime-input-text id="telefono" v-model="data.item.info.telefono" type="text" :disabled="!isInEdit"
              class="inputfield w-full" />
          </div>
          <div class="field col-12 md:col-6">
            <label for="partita_iva">Partita iva</label>
            <prime-input-text id="partita_iva" v-model="data.item.info.partita_iva" type="text" :disabled="!isInEdit"
              class="inputfield w-full" />
          </div>
          <div class="field col-12 md:col-6">
            <div class="flex align-items-center">
              <Checkbox id="is_point" v-model="data.item.info.is_point" class="m-2" :disabled="!isInEdit"
                :binary="true" />
              <label for="is_point">Point</label>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <div class="flex align-items-center">
              <Checkbox id="is_point_diretto" v-model="data.item.info.is_point_diretto" class="m-2"
                :disabled="!isInEdit" :binary="true" @update:modelValue="changeIsPointDiretto()" />
              <label for="is_point_diretto">Point Diretto Agf</label>
            </div>
            <div class="flex align-items-center" v-if="data.item.info.is_point_diretto">
              <div>
                <label class="m-2">Comune di network</label>
                <Dropdown v-model="data.item.info.cod_comune_network" :options="cities" :filter="true" optionLabel="name" optionValue="id" placeholder="Seleziona comune" @update:modelValue="removeErrors('network')" :disabled="!isInEdit" />
                <div>
                  <small class="m-2 p-error" v-if="validationErrors.comuneNetwork">Campo necessario per un point
                    diretto</small>
                </div>
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <div class="flex align-items-center">
              <Checkbox id="show_map" v-model="data.item.info.show_map" class="m-2" :disabled="!isInEdit" :binary="true"
                @update:modelValue="changeShowMap()" />
              <label for="show_map">Visibile sulla mappa Landing</label>
            </div>
            <div v-if="data.item.info.show_map">
              <div class="col-12 flex flex-column">
                <label class="m-2">Indirizzo</label>
                <InputText class="w-full" type="text" v-model="data.item.info.address"
                  placeholder="Inserisci toponimo indirizzo civico e comune"
                  @update:modelValue="removeErrors('address')" :disabled="!isInEdit" />
                <small class="m-2 p-error" v-if="validationErrors.address">Campo necessario per un agente da mostrare
                  sulla mappa</small>
              </div>
              <div class="flex align-items-center justify-content-between">
                <div class="flex flex-column col-12 md:col-6">
                  <label class="m-2">Latitudine</label>
                  <InputMask v-model="data.item.info.lat" mask="99.999?99" placeholder="esempio 41.09840"
                    @update:modelValue="removeErrors('address')" :disabled="!isInEdit" />
                  <small class="m-2 p-error" v-if="validationErrors.lat">Campo necessario per un agente da mostrare
                    sulla mappa</small>
                </div>
                <div class="flex flex-column col-12 md:col-6">
                  <label class="m-2">Longitudine</label>
                  <InputMask v-model="data.item.info.lng" mask="99.999?99" placeholder="esempio 16.87833"
                    @update:modelValue="removeErrors('address')" :disabled="!isInEdit" />
                  <small class="m-2 p-error" v-if="validationErrors.lng">Campo necessario per un agente da mostrare
                    sulla mappa</small>
                </div>
              </div>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <div class="flex align-items-center">
              <Checkbox id="notificaSwitchout" v-model="data.item.info.notificaSwitchout" class="m-2"
                :disabled="!isInEdit" :binary="true" />
              <label for="notificaSwitchout">Invia notifica SwitchOut</label>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <div class="flex align-items-center">
              <Checkbox id="notificaStorni" v-model="data.item.info.notificaStorni" class="m-2" :disabled="!isInEdit"
                :binary="true" />
              <label for="notificaStorni">Invia notifica Storni</label>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <div class="flex align-items-center">
              <Checkbox id="notificaPreavvisi" v-model="data.item.info.notificaPreavvisi" class="m-2"
                :disabled="!isInEdit" :binary="true" />
              <label for="notificaPreavvisi">Invia notifica Preavvisi</label>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <div class="flex align-items-center">
              <Checkbox id="can_select_bimestrale" v-model="data.item.info.can_select_bimestrale" class="m-2"
                :disabled="!isInEdit" :binary="true" />
              <label for="can_select_bimestrale">Abilita selezione bimestralità</label>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <div class="flex align-items-center">
              <Checkbox id="can_view_simulator" v-model="data.item.info.can_view_simulator" class="m-2"
                :disabled="!isInEdit" :binary="true" />
              <label for="can_view_simulator">Visualizzazione Simulatore Cte</label>
            </div>
          </div>
          <div class="field col-12 md:col-6">
            <div class="flex flex-column">
              <label class="mb-2">Periodo fatturazione</label>
              <Dropdown v-model="data.item.info.default_type_periodo" :options="frequenze" optionLabel="name" optionValue="id"
                placeholder="Seleziona periodo di fatturazione" class="w-full md:w-14rem" :disabled="!isInEdit" />
            </div>
          </div>
        </div>
        <Fieldset legend="Impostazioni Gettoni" class="w-full m-2">
          <div class="formgrid grid">
            <div class="field col-12 md:col-6">
              <div class="flex flex-column">
                <label class="mb-2">Periodo pagamento gettone</label>
                <Dropdown v-model="data.item.info.gettone_periodo" :options="periodi_gettone" optionLabel="label" optionValue="value" placeholder="Seleziona periodo" class="w-full md:w-14rem" :disabled="!isInEdit" />
              </div>
            </div>
            <div class="field col-12 md:col-6">
              <div class="flex flex-column">
                <label class="mb-2">Pagamento rid gettone</label>
                <InputNumber v-model="data.item.info.gettone_rid" inputId="currency-italy" mode="currency" currency="EUR" locale="it-IT" class="w-full md:w-14rem" :disabled="!isInEdit" />
              </div>
            </div>
            <div class="field col-12 md:col-6">
              <div class="flex flex-column">
                <label class="mb-2">Tipo storno</label>
                <Dropdown v-model="data.item.info.gettone_tipo_storno" :options="types_storno" optionLabel="label" optionValue="value" placeholder="Seleziona tipo storno" :disabled="!isInEdit" />
              </div>
            </div>
            <div class="field col-12 md:col-6">
              <div class="flex flex-column">
                <label class="mb-2">Mesi di storno</label>
                <Dropdown v-model="data.item.info.gettone_mesi_storno" :options="mesi_storno" optionLabel="label" optionValue="value" placeholder="Seleziona mesi di storno" :disabled="!isInEdit" />
              </div>
            </div>
          </div>
        </Fieldset>

        <div class="grid p-jc-end">
          <div class="col-12 text-right" v-if="!isInEdit">
            <prime-button icon="pi pi-pencil" class="p-button-rounded p-button-success mr-2" @click="onEditInfo" />
          </div>

          <div class="col-12 text-right" v-if="isInEdit">
            <prime-button icon="pi pi-times" class="p-button-rounded p-button-danger mr-2" @click="onAbortInfoEdit" />
            <prime-button icon="pi pi-check" class="p-button-rounded p-button-success mr-2" @click="onUpdateInfo" />
          </div>
        </div>

      </div>
    </AccordionTab>
    <prime-accordion-tab header="Permessi Area Agente">
      <div v-if="data.item.id">
        <p class="mb-1">L'accesso all'area clienti è previsto per la mail: <b>{{ data.item.info.email }}</b></p>
        <p class="mb-1">Email inviata: <b>{{ data.item.info.access_email_sent == 1 ? 'SI' : 'NO' }}</b></p>
        <p class="mb-2">Data invio Email: <b>{{ moment(data.item.info.access_datetime_sent).isValid() ?
          moment(data.item.info.access_datetime_sent).format('DD-MM-YYYY - HH:mm') : '/' }}</b> </p>

        <div class="formgrid grid mt-3">
          <div class="field col-4">
            <label> <small>Invia a</small> </label>
            <prime-input-text v-model="forceMail" :placeholder="this.data.item.info.email" type="text"
              class="inputfield w-full" />
            <small class="p-error" v-if="validationErrors.isEmail">Formato non valido</small>
          </div>
          <div class="field col-4">
            <label> <small>Invia in ccn anche a</small> </label>
            <prime-input-text v-model="ccnMail" type="text" class="inputfield w-full" />
            <small class="p-error" v-if="validationErrors.isEmail">Formato non valido</small>
          </div>
          <div class="field col-4 flex align-items-end">
            <prime-button label="RESET PASSWORD e INVIA MAIL DI ACCESSO" icon="pi pi-envelope" iconPos="right"
              class="p-button p-button-primary" @click="sendAgentLoginEmail" />
          </div>
          <div class="col-12">
            <small v-if="forceMail.length > 0" class="p-error">
              Cambiando l'email di invio la password verrà modificata ma l'agente non la riceverà sulla sua mail ma su
              {{ forceMail }}
            </small>
          </div>
          <hr class="col-12">
          <div class="col-12 mb-3">
            <div class="flex align-items-center">
              <InputSwitch
                id="permessi-2fa-switch"
                v-model="data.item.info.two_factor_auth"
                :disabled="loading2fa || confirming2fa"
                @change="onToggleTwoFactorAuth"
                class="mr-2"
              />
              <label for="permessi-2fa-switch" class="font-bold cursor-pointer">
                Login OTP (2FA):
                <span :class="data.item.info.two_factor_auth ? 'text-green-600' : 'text-500'">
                  {{ data.item.info.two_factor_auth ? 'Attivo' : 'Disattivato' }}
                </span>
              </label>
            </div>
          </div>
          <div class="col-12">
            <h6>L'agente può vedere:</h6>
            <Checkbox v-model="data.item.info.can_view_offer" :binary="true" />
            <label class="ml-2">Dettagli offerta</label>
            <Checkbox v-model="data.item.info.can_view_offer_name" :binary="true" class="ml-4" />
            <label class="ml-2">Offerta Nome</label>
            <!-- <Checkbox v-model="data.item.info.can_view_commission" :binary="true" class="ml-4" />
            <label class="ml-2">Dettagli provvigioni</label>
            <Checkbox v-model="data.item.info.can_calculate_commission" :binary="true" class="ml-4" />
            <label class="ml-2">Modulo provvigioni</label>
            <Checkbox v-model="data.item.info.can_view_as" :binary="true" class="ml-4" />
            <label class="ml-2">Provvigioni subagenti</label> -->
            <Checkbox v-model="data.item.info.can_view_autolettura" :binary="true" class="ml-4" />
            <label class="ml-2">Visualizzazione autolettura</label>
            <Checkbox v-model="data.item.info.can_view_conguaglio" :binary="true" class="ml-4" />
            <label class="ml-2">Visualizzazione conguaglio</label>
            <Checkbox v-model="data.item.info.can_view_offer_generation" :binary="true" class="ml-4" />
            <label class="ml-2">Visualizzazione generazione offerta</label>
          </div>
          <div class="col-12 mt-4">
            <prime-button label="Salva" icon="pi pi-check" iconPos="right" class="p-button p-button-primary w-2"
              @click="changeCanView" />
          </div>

        </div>
      </div>
    </prime-accordion-tab>
    <prime-accordion-tab header="Modulistica">
      <div v-if="data.item.id" class="modulistica-section">
        <div class="modulistica-upload-grid modulistica-upload-grid--single">
          <div class="modulistica-card modulistica-card--accent">
            <div class="modulistica-card__head">
              <span class="modulistica-card__icon modulistica-card__icon--accent"><i class="pi pi-briefcase"></i></span>
              <div>
                <h4 class="modulistica-card__title">Documento tipizzato</h4>
                <p class="modulistica-card__desc">Visibile solo in ask_admin (non in area agenti)</p>
              </div>
            </div>
            <div class="modulistica-card__body form-file">
              <div class="field mb-3">
                <label class="modulistica-label">Tipo documento</label>
                <Dropdown
                  v-model="selectedTipoDocumento"
                  :options="tipiDocumentoModulistica"
                  optionLabel="name"
                  dataKey="id"
                  placeholder="Seleziona tipo documento"
                  class="inputfield w-full"
                  @change="onTipoDocumentoChange"
                />
                <div v-show="validationErrorsTipo.tipo && submittedTipo" class="p-error">Campo richiesto.</div>
              </div>
              <div v-if="isTipoAltro" class="field mb-3">
                <label class="modulistica-label">Titolo</label>
                <prime-input-text v-model="fileToUploadTipo.title" type="text" class="inputfield w-full" placeholder="Es. Contratto, Allegato..." />
                <div v-show="validationErrorsTipo.title && submittedTipo" class="p-error">Campo richiesto.</div>
              </div>
              <div class="field mb-3">
                <label class="modulistica-label">{{ isTipoAltro ? 'File (anche multipli)' : 'File PDF' }}</label>
                <div class="modulistica-dropzone" :class="{ 'has-file': fileToUploadTipo.file.length > 0 }">
                  <i class="pi" :class="fileToUploadTipo.file.length > 0 ? 'pi-check-circle' : 'pi-cloud-upload'"></i>
                  <span class="modulistica-dropzone__text">{{ fileToUploadTipoLabel }}</span>
                  <input
                    id="upload-tipo"
                    type="file"
                    ref="fileTipo"
                    :multiple="isTipoAltro"
                    @change="handleFileUploadTipo($event)"
                    :accept="isTipoAltro ? undefined : 'application/pdf,.pdf'"
                  />
                </div>
                <ul v-if="fileToUploadTipo.file.length > 1" class="modulistica-file-list">
                  <li v-for="(f, idx) in fileToUploadTipo.file" :key="idx">{{ f.name }}</li>
                </ul>
                <div v-show="validationErrorsTipo.files && submittedTipo" class="p-error">Campo richiesto.</div>
                <div v-show="validationErrorsTipo.type && submittedTipo" class="p-error">Formato non consentito (solo PDF)</div>
              </div>
              <prime-button label="Carica documento" icon="pi pi-upload" iconPos="right" class="p-button p-button-primary"
                @click="uploadModuloTipo" />
            </div>
          </div>
        </div>

        <div v-if="modulisticaList.length > 0" class="modulistica-list mt-4">
          <div class="modulistica-list__header">
            <h4>Documenti caricati</h4>
            <span class="modulistica-list__count">{{ modulisticaList.length }}</span>
          </div>
          <DataTable :value="modulisticaList" responsiveLayout="scroll" class="modulistica-table">
            <Column field="titolo" header="Titolo"></Column>
            <Column field="origine" header="Visibilità">
              <template #body="{ data }">
                <span class="modulistica-badge" :class="data.origine === 'admin' ? 'is-admin' : 'is-agente'">
                  {{ data.origine === 'admin' ? 'Solo admin' : 'Area agenti' }}
                </span>
              </template>
            </Column>
            <Column field="data_inserimento" header="Data Inserimento">
              <template #body="{ data }">
                {{ formatDate(data.data_inserimento) }}
              </template>
            </Column>
            <Column :exportable="false" style="min-width:8rem" header="Azioni">
              <template #body="slotProps">
                <Button icon="pi pi-download" class="p-button-rounded p-button-primary mr-2"
                  @click="downloadModulo(slotProps.data)" />
                <Button icon="pi pi-trash" class="p-button-rounded p-button-danger"
                  @click="deleteModulo(slotProps.data)" />
              </template>
            </Column>
          </DataTable>
        </div>
        <div v-else class="modulistica-empty mt-4">
          <i class="pi pi-inbox"></i>
          <span>Nessun documento caricato per questo agente</span>
        </div>
      </div>
    </prime-accordion-tab>
    <prime-accordion-tab header="Offerte">
      <div class="w-full p-3" v-if="loadingOfferte || loadingTreeSubagentiFlat">
        <Skeleton class="mb-2"></Skeleton>
        <Skeleton width="10rem" class="mb-2"></Skeleton>
        <Skeleton width="5rem" class="mb-2"></Skeleton>
        <Skeleton height="2rem" class="mb-2"></Skeleton>
        <Skeleton width="10rem" height="4rem"></Skeleton>
      </div>
      <div v-else>
        <!-- Sezione Controlli Superiore -->
        <div class="formgrid grid mb-4">
          <!-- MultiSelect Offerte -->
          <div class="field col-12 md:col-6">
            <AutoComplete :inputClass="'w-full'" :inputStyle="{ width: '100%' }" v-model="selectedOfferte" multiple :suggestions="offerte" @complete="searchOfferta" optionLabel="name" optionValue="id" placeholder="Cerca offerta"/>
            <div v-show="validationErrors.offerta && submitted" class="p-error">
              Campo richiesto.
            </div>
          </div>
  
          <!-- MultiSelect Agenti -->
          <div class="field col-12 md:col-6">
            <MultiSelect v-model="selectedAgentsTreeFlat" :options="agentsTreeFlat" dataKey="id" :filter="true"
              optionLabel="name" placeholder="Seleziona agenti" class="inputfield w-full" />
            <div v-show="validationErrors.agent && submitted" class="p-error">
              Campo richiesto.
            </div>
          </div>
  
          <!-- Pulsanti Azione -->
          <div class="field col-12 md:col-2">
            <prime-button label="Associa offerte" icon="pi pi-paperclip" iconPos="right" class="p-button p-button-primary w-full h-4rem" :disabled="(!selectedOfferte?.length || !selectedAgentsTreeFlat?.length)" @click="associateOfferte"/>
          </div>
  
          <div class="field col-12 md:col-2">
            <prime-button label="Associa offerte alla sottorete" icon="pi pi-paperclip" iconPos="right" class="p-button p-button-primary w-full h-4rem" :disabled="(!selectedOfferte?.length || !selectedAgentsTreeFlat?.length || selectedAgentsTreeFlat.length > 1)" @click="associateOfferteToAllSubagents"/>
          </div>
  
          <div class="field col-12 md:col-2">
            <prime-button label="Dissocia offerte" icon="pi pi-minus-circle" iconPos="right" class="p-button p-button-danger w-full h-4rem" :disabled="(!selectedOfferte?.length || !selectedAgentsTreeFlat?.length)" @click="dissociateOfferte"/>
          </div>
  
          <div class="field col-12 md:col-2">
            <prime-button label="Dissocia offerte dalla sottorete" icon="pi pi-minus-circle" iconPos="right" class="p-button p-button-danger w-full h-4rem" :disabled="(!selectedOfferte?.length || !selectedAgentsTreeFlat?.length || selectedAgentsTreeFlat.length > 1)" @click="dissociateOfferteToAllSubagents"/>
          </div>
  
          <div class="field col-12 md:col-2">
            <prime-button label="Copia offerte da altro agente" icon="pi pi-plus" iconPos="right" class="p-button p-button-success w-full h-4rem"  @click="visibleDialogCloneOfferteFromOtherAgent = true"/>
          </div>
        </div>
  
        <Dialog v-model:visible="visibleDialogCloneOfferteFromOtherAgent" header="Copia offerte da un altro agente" :modal="true"
          :style="{ width: '80vw' }">
          <Loader v-if="loader"/>
          <div class="card flex justify-content-center">
            <Dropdown v-model="selectedAgentForCloneOfferte" :options="agenti" filter optionLabel="name" placeholder="Seleziona un agente" class="w-full md:w-14rem" @change="getOfferteAgent(selectedAgentForCloneOfferte.id)"/>
          </div>
          <div class="flex flex-wrap mb-3" v-if="offerteClone.length > 0">
            <Chip :label="offerta.name" v-for="offerta in offerteClone" :key="offerta.id" class="m-2"/>
          </div>
          <template #footer>
            <Button @click="cloneOfferte" :disabled="selectedAgentForCloneOfferte == null || offerteClone.length == 0" label="Clona offerte" class="p-button-sm" />
            <Button @click="closeDialogCloneOfferteFromOtherAgente" label="Chiudi" class="p-button-sm p-button-secondary ml-2" />
          </template>
        </Dialog>
  
        <!-- Dialog Offerte -->
        <Dialog v-model:visible="dialogVisible" :header="selectedAgentName + ' - Offerte'" :modal="true"
          :style="{ width: '80vw' }" class="offers-dialog">
          <div class="offers-grid">
            <div v-for="offerta in selectedAgentOffers" :key="offerta.id" class="offer-card">
              <div class="flex items-start gap-2 p-3">
                <Checkbox v-model="selectedAgentOfferteTree[selectedAgentKey]" name="offerta" :value="offerta"/>
                <div class="flex-grow ml-2">
                  <router-link :to="`/ask/offerte/listini/${offerta.id}/dettagli`" target="_blank" class="offer-name">
                    {{ offerta.name }}
                  </router-link>
                  <div class="offer-date">
                    {{ offerta.data_creazione ? moment(offerta.data_creazione).format('DD-MM-YYYY') : '--' }}
                  </div>
                  <div class="offer-pricing">
                    <span>Spread: {{ formatOfferSpread(offerta) }}</span>
                    <span>PCV: {{ formatOfferPcv(offerta) }}</span>
                  </div>
                </div>
              </div>
              <div class="flex align-items-center m-2 justify-content-center" v-if="selectedAgentOfferteTree[selectedAgentKey].some(offer => offer.id == offerta.id) && !selectedAgent.id_parent">
                <label class="m-1">Duplicabile</label>
                <Checkbox v-model="offerta.duplicabile" :binary="true"/>
              </div>
            </div>
          </div>
          <template #footer>
            <Button @click="applyNewGroupOfferteToAgent(selectedAgent)" label="Applica modifiche" class="p-button-sm" />
            <Button @click="closeDialog" label="Chiudi" class="p-button-sm p-button-secondary ml-2" />
          </template>
        </Dialog>
  
        <!-- Struttura Gerarchica Agenti -->
         <div class="w-full p-3" v-if="loadingTreeSubagenti">
          <Skeleton class="mb-2"></Skeleton>
          <Skeleton width="10rem" class="mb-2"></Skeleton>
          <Skeleton width="5rem" class="mb-2"></Skeleton>
          <Skeleton height="2rem" class="mb-2"></Skeleton>
          <Skeleton width="10rem" height="4rem"></Skeleton>
        </div>
        <div v-else class="org-chart-container bg-gray-100 p-6 min-h-screen">
          <div v-for="agent in data.item.tree_subagenti" :key="agent.id" class="org-tree">
            <div class="org-card root-card">
              <div class="card-header">
                <div class="agent-info">
                  <div class="agent-avatar">
                    <i class="pi pi-user text-xl"></i>
                  </div>
                  <div class="agent-details">
                    <h3 class="agent-name">{{ agent.name }}</h3>
                    <span class="agent-role">Agente Principale</span>
                  </div>
                </div>
                <div class="card-actions">
                  <span class="offers-badge">
                    {{ agent.offerte.length }} offerte
                  </span>
                  <Button icon="pi pi-folder" @click="showOffers(agent)" class="p-button-rounded p-button-text"
                    v-tooltip.top="'Visualizza offerte'" />
                </div>
              </div>
            </div>
  
            <!-- Livello Sub Agenti -->
            <div v-if="agent.children && agent.children.length" class="org-level">
              <div class="connector-line"></div>
              <div class="subagents-container">
                <div v-for="subAgent in agent.children" :key="subAgent.id" class="subagent-branch">
                  <div class="org-card subagent-card">
                    <div class="card-header">
                      <div class="agent-info">
                        <div class="agent-avatar">
                          <i class="pi pi-users text-lg"></i>
                        </div>
                        <div class="agent-details">
                          <h4 class="agent-name">{{ subAgent.name }}</h4>
                          <span class="agent-role">Sub Agente</span>
                        </div>
                      </div>
                      <div class="card-actions">
                        <span class="offers-badge">
                          {{ subAgent.offerte.length }} offerte
                        </span>
                        <Button icon="pi pi-folder" @click="showOffers(subAgent)" class="p-button-rounded p-button-text"
                          v-tooltip.top="'Visualizza offerte'" />
                        <Button v-if="subAgent.children?.length"
                          :icon="subAgent.showSubagents ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"
                          @click="subAgent.showSubagents = !subAgent.showSubagents"
                          class="p-button-rounded p-button-text"
                          v-tooltip.top="subAgent.showSubagents ? 'Nascondi sottoagenti' : 'Mostra sottoagenti'" />
                      </div>
                    </div>
                  </div>
  
                  <!-- Sub Sub Agenti -->
                  <div v-if="subAgent.showSubagents && subAgent.children && subAgent.children.length"
                    class="org-level nested-level">
                    <div class="connector-line"></div>
                    <div class="subagents-container">
                      <div v-for="nestedAgent in subAgent.children" :key="nestedAgent.id" class="org-card nested-card">
                        <div class="card-header">
                          <div class="agent-info">
                            <div class="agent-avatar">
                              <i class="pi pi-user-plus text-lg"></i>
                            </div>
                            <div class="agent-details">
                              <h5 class="agent-name">{{ nestedAgent.name }}</h5>
                              <span class="agent-role">Sub Sub Agente</span>
                            </div>
                          </div>
                          <div class="card-actions">
                            <span class="offers-badge">
                              {{ nestedAgent.offerte.length }} offerte
                            </span>
                            <Button icon="pi pi-folder" @click="showOffers(nestedAgent)"
                              class="p-button-rounded p-button-text" v-tooltip.top="'Visualizza offerte'" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div v-if="data.item.id">
      </div> -->

    </prime-accordion-tab>
    <prime-accordion-tab header="Agenzia e subagenti">
      <div class="w-full p-3" v-if="loadingSubagenti">
        <Skeleton class="mb-2"></Skeleton>
        <Skeleton width="10rem" class="mb-2"></Skeleton>
        <Skeleton width="5rem" class="mb-2"></Skeleton>
        <Skeleton height="2rem" class="mb-2"></Skeleton>
        <Skeleton width="10rem" height="4rem"></Skeleton>
      </div>
      <div v-else>
        <div class="formgrid grid">
          <div class="field col-12 md:col-12 my-6">
            <p>Seleziona agenzia di appartenenza</p>
            <Dropdown v-model="data.item.info.id_parent" :options="agenti" :filter="true" optionLabel="name"
              optionValue="id" placeholder="Seleziona..." class="inputfield w-full" />
            <div class="col-12 my-2 flex justify-content-end">
              <prime-button label="Associa agenzia" icon="pi pi-check" iconPos="right" class="p-button p-button-primary"
                @click="associateAgencyToAgent" />
            </div>
          </div>

          <Divider />

          <div class="field col-12 md:col-12 my-6">
            <div class="my-2">
              <Checkbox v-model="data.item.info.has_subagents" :binary="true" inputId="isAgency" />
              <label for="isAgency" class="ml-2"> Agenzia </label>
            </div>


            <MultiSelect :disabled="!data.item.info.has_subagents" v-model="selectedAgenti" :options="agenti"
              dataKey="id" :filter="true" optionLabel="name" optionValue="id" placeholder="Aggiungi subagenti"
              class="inputfield w-full" />
            <div class="col-12 my-2 flex justify-content-end">
              <prime-button label="Associa subagenti" icon="pi pi-check" iconPos="right"
                class="p-button p-button-primary" @click="associateSubagentsToAgent" />
            </div>
            <!-- :disabled="selectedAgenti.length == 0" -->
            <div v-if="data.item.subagenti.length > 0">
              <DataTable :value="data.item.subagenti" responsiveLayout="scroll">
                <Column field="name" header="Subagente"></Column>
                <Column :exportable="false" style="min-width:8rem">
                  <template #body="slotProps">
                    <p class="p-error cursor-pointer" @click="dissociateSubagenti(slotProps.data)">Dissocia</p>
                  </template>
                </Column>
              </DataTable>
            </div>

          </div>


          <!-- <div class="field col-12 md:col-12">
            <Dropdown v-model="typeAgent" :options="typeAgents" optionLabel="label" optionValue="val" placeholder="Tipo agente" class="inputfield w-full" />
          </div>
          <div v-if="typeAgent == 1" class="field col-12 md:col-12">
            <Dropdown v-model="selectedAgenzia" :options="agenzie" optionLabel="name" optionValue="id" placeholder="Seleziona agenzia di appartenenza" class="inputfield w-full" />
          </div>
          <div v-if="typeAgent == 2" class="field col-12 md:col-12">
            <MultiSelect v-model="selectedAgenti" :options="agenti" dataKey="id" :filter="true" optionLabel="name" optionValue="id" placeholder="Aggiungi subagenti" class="inputfield w-full" />
            <div class="col-12 mt-4">
              <DataTable :value="data.item.subagenti" responsiveLayout="scroll">
                <Column field="name" header="Nome"></Column>
                <Column :exportable="false" style="min-width:8rem">
                  <template #body="slotProps">
                    <p class="p-error cursor-pointer" @click="dissociateSubagenti(slotProps.data)" >Dissocia</p>
                  </template>
                </Column>
              </DataTable>
            </div>
          </div>
          <div v-if="typeAgent == 3" class="field col-12 md:col-12">
            <MultiSelect v-model="selectedAgenzia" :options="agenzie" optionLabel="name" optionValue="id" placeholder="Seleziona agenzie da supervisionare" class="inputfield w-full" />
          </div> -->
        </div>
      </div>
    </prime-accordion-tab>
    <prime-accordion-tab header="Fatture Aperte">
      <div v-if="data.item.id">
        <div class="grid">
          <div class="col-12 md:col-6 lg:col-3">
            <div class="surface-0 shadow-2 p-3 border-1 border-50 border-round">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block text-500 font-medium mb-3">Totale Scoperto</span>
                  <div class="text-900 font-medium text-xl">{{ formatCurrency(fattureAperte.totale_scoperto || 0) }}</div>
                </div>
                <div class="flex align-items-center justify-content-center bg-red-100 border-round" style="width:2.5rem;height:2.5rem">
                  <i class="pi pi-euro text-red-500 text-xl"></i>
                </div>
              </div>
            </div>
          </div>
          
          <div class="col-12 md:col-6 lg:col-3">
            <div class="surface-0 shadow-2 p-3 border-1 border-50 border-round">
              <div class="flex justify-content-between mb-3">
                <div>
                  <span class="block text-500 font-medium mb-3">Numero Fatture</span>
                  <div class="text-900 font-medium text-xl">{{ fattureAperte.numero_fatture || 0 }}</div>
                </div>
                <div class="flex align-items-center justify-content-center bg-blue-100 border-round" style="width:2.5rem;height:2.5rem">
                  <i class="pi pi-file text-blue-500 text-xl"></i>
                </div>
              </div>
            </div>
          </div>

          <div class="col-12">
            <DataTable :value="filteredFatture" :paginator="true" :rows="10" responsiveLayout="scroll" class="p-datatable-sm" dataKey="id"  >
              <template #header>
                <div class="flex align-items-center justify-content-between">
                  <TreeSelect v-model="modelfilterAgente" :options="sottoAgenti" selectionMode="multiple" display="chip" filter optionLabel="name" optionValue="name" placeholder="Seleziona un agente" class="col-10" @node-select="customfilterCallback($event)" @node-unselect="customfilterCallback($event)">
                    <template #value="{value,placeholder}">
                      <div v-if="value.length" class="flex flex-wrap align-items-center">
                        <div class="m-1" v-for="agente in value" :key="agente.id">
                          <Chip :label="agente.name" removable @remove="customfilterCallback(agente, true)"/>
                        </div>
                      </div>
                      <div v-else>
                        {{ placeholder }}
                      </div>
                    </template>
                  </TreeSelect>
                  <Button icon="pi pi-download" class="col-1 p-burron-rounded p-button-raised p-button-success" v-if="filteredFatture.length" @click="exportTab()"/>
                </div>
              </template>
              <Column field="numero" header="Numero Fattura" sortable>
                <template #body="slotProps">
                  <a href="#" 
                     class="text-primary hover:underline" 
                     @click.prevent="openLink(`clienti/fatture/${slotProps.data.numero}`)">
                    {{ slotProps.data.numero }}
                  </a>
                </template>
              </Column>
              <Column field="agente" header="Agente firmatario" sortable filterField="agente" :showFilterMenu="false" >
                <template #body="slotProps">
                  <a href="#" 
                     class="text-primary hover:underline" 
                     @click.prevent="openLink(`agenti/${slotProps.data.id_agente}`)">
                    {{ slotProps.data.agente }}
                  </a>
                </template>
              </Column>
              <Column field="rappresentante" header="Rappresentante" sortable>
                <template #body="slotProps">
                  <a href="#" 
                     class="text-primary hover:underline" 
                     @click.prevent="openLink(`rappresentanti/${slotProps.data.id_rappresentante}`)">
                    {{ slotProps.data.rappresentante }}
                  </a>
                </template>
              </Column>
              <Column field="cliente" header="Cliente" sortable>
                <template #body="slotProps">
                  <a href="#" 
                     class="text-primary hover:underline" 
                     @click.prevent="openLink(`clienti/${slotProps.data.client_id}`)">
                    {{ slotProps.data.cliente }}
                  </a>
                </template>
              </Column>
              <Column field="data_emissione" header="Data Emissione" sortable>
                <template #body="slotProps">
                  {{ formatDate(slotProps.data.data_emissione) }}
                </template>
              </Column>
              <Column field="data_scadenza" header="Data Scadenza" sortable>
                <template #body="slotProps">
                  {{ formatDate(slotProps.data.data_scadenza) }}
                </template>
              </Column>
              <Column field="importo_totale" header="Importo Totale" sortable>
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.importo_totale) }}
                </template>
              </Column>
              <Column field="importo_pagato" header="Importo Pagato" sortable>
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.importo_pagato) }}
                </template>
              </Column>
              <Column field="saldo" header="Saldo" sortable>
                <template #body="slotProps">
                  {{ formatCurrency(slotProps.data.saldo) }}
                </template>
              </Column>
            </DataTable>
          </div>
        </div>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Ticket">
      <prime-data-table
        :value="data.item.ticket"
        responsiveLayout="scroll"
        :paginator="true"
        :rows="10"
        v-if="data.item.ticket && data.item.ticket.length > 0"
      >
        <prime-column
          field="id_ticket"
          header="ID Ticket"
          :sortable="true"
        ></prime-column>
        <prime-column
          field="title"
          header="Titolo"
          :sortable="true"
        ></prime-column>
        <prime-column
          field="datetime"
          header="Data Creazione"
          :sortable="true"
        >
          <template #body="{ data }">
            {{ moment(data.datetime).format("DD/MM/YYYY HH:mm") }}
          </template>
        </prime-column>
      </prime-data-table>
      <div v-else class="text-center p-4">
        Nessun ticket trovato
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Provvigioni">
      <div v-if="data.item.id">
        <div class="formgrid grid mb-4">
          <div class="field col-12 md:col-6">
            <label for="anno">Anno</label>
            <Dropdown 
              v-model="selectedAnno" 
              :options="anniDisponibili" 
              optionLabel="name" 
              optionValue="value" 
              placeholder="Seleziona anno" 
              class="w-full"
              @change="cercaProvvigioni"
            />
          </div>
        </div>

        <div v-if="provvigioni.monthly_totals && Object.keys(provvigioni.monthly_totals).length > 0" class="mb-4">
          <h5>Fatture Acquisto</h5>
          <div class="grid">
            <div v-for="(totale, mese) in provvigioni.monthly_totals" :key="mese" class="col-12 md:col-3 lg:col-2">
              <div class="surface-0 shadow-2 p-3 border-1 border-50 border-round">
                <div class="flex justify-content-between mb-3">
                  <div>
                    <span class="block text-500 font-medium mb-3">{{ mese }}</span>
                    <div class="text-900 font-medium text-xl">{{ formatCurrency(totale) }}</div>
                  </div>
                  <div class="flex align-items-center justify-content-center bg-green-100 border-round" style="width:2.5rem;height:2.5rem">
                    <i class="pi pi-euro text-green-500 text-xl"></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div v-if="provvigioni.fatture_details && provvigioni.fatture_details.length > 0" class="mb-4">
          <h5>Dettaglio Fatture Acquisto</h5>
          <DataTable :value="provvigioni.fatture_details" :paginator="true" :rows="10" responsiveLayout="scroll" class="p-datatable-sm">
            <Column field="numero" header="Numero Fattura" sortable>
              <template #body="{ data }">
                <a 
                  href="#" 
                  class="text-primary hover:underline cursor-pointer" 
                  @click.prevent="goToFatturaDetail(data.id_fattura)"
                >
                  {{ data.numero }}
                </a>
              </template>
              <template #footer>
                <div class="font-bold text-primary">Totali</div>
              </template>
            </Column>
            <Column field="data_emissione" header="Data Emissione" sortable>
              <template #body="{ data }">
                {{ formatDate(data.data_emissione) }}
              </template>
              <template #footer>
                <div></div>
              </template>
            </Column>
            <Column field="totale_fattura" header="Totale Fattura" sortable>
              <template #body="{ data }">
                {{ formatCurrency(data.totale_fattura) }}
              </template>
              <template #footer>
                <div class="font-bold text-lg text-primary">{{ formatCurrency(calcolaTotaleComplessivo) }}</div>
              </template>
            </Column>
            <Column field="pagato" header="Totale Pagato" sortable>
              <template #body="{ data }">
                {{ formatCurrency(data.pagato) }}
              </template>
              <template #footer>
                <div class="font-bold text-lg text-primary">{{ formatCurrency(calcolaTotaleComplessivoPagato) }}</div>
              </template>
            </Column>
          </DataTable>
        </div>

        <div v-if="selectedAnno" class="mt-4">
          <RiepilogoProvvigioni 
            :id-agente="data.item.id"
            :anno-selezionato="selectedAnno"
            :auto-search="true"
          />
        </div>

        <div v-if="selectedAnno && !loader && (!provvigioni.monthly_totals || Object.keys(provvigioni.monthly_totals).length === 0) && (!provvigioni.fatture_details || provvigioni.fatture_details.length === 0)" class="text-center p-4">
        </div>
      </div>
    </prime-accordion-tab>

    <div v-if="data.item.info.gettone_periodo">
      <AccordionTab header="Scaglioni">
        <Card>
          <template #title>
            <div class="flex justify-content-between align-items-center">
              Scaglioni presenti
              <Button icon="pi pi-plus" v-tooltip.left="`Inserisci nuovo scaglione`" @click="showDialogNewScaglione()"/>
            </div>
          </template>
          <template #content>
            <div class="w-full">
              <div v-if="Object.keys(scaglioni).length">
                <div v-for="(gruppo, n_gruppo) in scaglioni" :key="n_gruppo" class="flex">
                  <h3 class="col-12 md:col-2">Gruppo {{ n_gruppo }}</h3>
                  <div class="col-12 md:col-10 flex flex-wrap">
                    <div v-for="scaglione in gruppo" :key="scaglione.id" class="">
                      <Chip class="m-2" :label="`${scaglione.min}${scaglione.max ? ' - ' + scaglione.max : '+'}`" />
                    </div>
                  </div> 
                </div>
              </div>
              <div v-else>
                Crea un nuovo scaglione
              </div>
            </div>
          </template>
        </Card>
      </AccordionTab>
      <AccordionTab header="Gettoni">
        <div v-if="Object.keys(scaglioni).length">
          <div class="flex align-items-center">
            <div class="bg-warning m-2" style="width: 70px; aspect-ratio: 7;"></div>
            <div>Offerta duplicabile</div>
          </div>
          <Accordion :activeIndex="0" :multiple="true">
            <AccordionTab v-for="(gruppo, n_gruppo) in scaglioni" :key="n_gruppo">
              <template #header>
                Gruppo {{ n_gruppo }}
              </template>
              <DataTable v-model:filters="filters_offerta_gettone" :globalFilterFields="['offerta']" dataKey="id_offerta" filterDisplay="row" v-model:editingRows="editingRows[n_gruppo]" :value="gettoni[n_gruppo]" editMode="row" @row-edit-save="onRowEditSave($event, n_gruppo)" :rowClass="rowClass">
                <Column field="offerta" header="Offerta">
                  <template #body="{ data }">
                    {{ data.offerta }} <small :class="getPropMandato(data.mandato, 'class')">{{ getPropMandato(data.mandato, 'label')}}</small>
                  </template>
                  <template #filter="{ filterModel, filterCallback }">
                    <InputText v-model="filterModel.value" type="text" @input="filterCallback()" class="p-column-filter" placeholder="Cerca offerta"/>
                  </template>
                </Column>
                <Column field="" header="Storno">
                  <template #body="{ data }">
                    {{ data.storno ? 'Si' : 'No'}}
                  </template>
                  <template #editor="{ data }">
                    <Checkbox v-model="data.storno" :binary="true"/>
                  </template>
                </Column>
                <Column v-for="scaglione of gruppo" :key="scaglione.label" :field="scaglione.label"
                  :header="scaglione.label" style="width: 10rem">
                  <template #editor="{ data, field }">
                    <InputNumber v-model="data[field]" inputId="currency-italy" mode="currency" currency="EUR" locale="it-IT" class="input-gettone"/>
                  </template>
                  <template #body="{ data, field }">
                    {{ data[field] }} €
                  </template>
                </Column>
                <Column :rowEditor="true" style="width: 10%; min-width: 8rem" bodyStyle="text-align:center"></Column>
              </DataTable>
            </AccordionTab> 
          </Accordion>
        </div>
        <div v-else>
          Crea un nuovo scaglione
        </div>
      </AccordionTab>
    </div>
  </Accordion>

  <Dialog v-model:visible="visibleDialogNewScaglione" modal header="Nuovo scaglione" :style="{ width: '50rem' }">
    <div class="flex flex-column col-12 align-items-center">
      <label for="gruppo" class="font-bold block mb-2">Gruppo</label>
      <Dropdown v-model="new_scaglione.gruppo" :options="gruppi" optionLabel="value" optionValue="value" optionDisabled="disabled" placeholder="Seleziona un gruppo" class="w-full md:w-14rem" @update:modelValue="changeGruppo($event)"/>
    </div>
    <div class="flex justify-content-around col-12" v-if="new_scaglione.gruppo">
      <div class="flex flex-column">
        <label for="minmax" class="font-bold block mb-2">Minimo</label>
        <InputNumber v-model="new_scaglione.min.value" inputId="integeronly" disabled />
      </div>
      <div class="flex flex-column">
        <label for="minmax" class="font-bold block mb-2">Massimo</label>
        <InputNumber v-model="new_scaglione.max.value" inputId="minmax" :min="new_scaglione.max.min"
          :max="new_scaglione.max.max" :disabled="isNullMaxNewScaglione" />
        <div class="m-2">
          <label class="mr-2">Infinito</label>
          <Checkbox v-model="isNullMaxNewScaglione" :binary="true" @click="resetMaxNewScaglione()" />
        </div>
      </div>
    </div>
    <div class="mt-2 flex justify-content-center" v-if="!canSaveNewScaglione">
      <Button icon="pi pi-send" @click="saveNewScaglione()" label="Salva" :disabled="canSaveNewScaglione" />
    </div>
  </Dialog>
</template>
<script>

import AgentiService from '@/services/ask-management/agenti-service'
import UtilityService from '@/services/ask-management/utility-service'
import { getCurrentInstance } from 'vue';
import { FilterMatchMode } from 'primevue/api';
import Loader from '@/components/Loader.vue'
import PrimeButton from 'primevue/button'
import PrimeInputText from 'primevue/inputtext'
// import PrimeAccordion from 'primevue/accordion'
import PrimeAccordionTab from 'primevue/accordiontab'
import PrimeDataTable from 'primevue/datatable'
import PrimeColumn from 'primevue/column'
import { useToast } from "primevue/usetoast";
import * as XLSX from "xlsx";

import moment from 'moment'
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import RiepilogoProvvigioni from '@/components/pratiche/RiepilogoProvvigioni.vue'
import ImpersonateButton from '@/components/ask/details/ImpersonateButton.vue'
import SupplyRiepilogoSection from '@/components/ask/details/SupplyRiepilogoSection.vue'
import InputSwitch from 'primevue/inputswitch'
import ConfirmDialog from 'primevue/confirmdialog'

export default {
  name: 'ViewAgentiDetail',
  components: {
    PrimeButton,
    ImpersonateButton,
    PrimeInputText,
    // PrimeAccordion,
    PrimeAccordionTab,
    PrimeDataTable,
    PrimeColumn,
    Loader,
    Dropdown,
    DataTable,
    Column,
    RiepilogoProvvigioni,
    SupplyRiepilogoSection,
    InputSwitch,
    ConfirmDialog
  },

  data() {
    return {
      moment,
      dialogVisible: false,
      loader: false,
      loading2fa: false,
      confirming2fa: false,
      loadingAndamento: false,
      loadedAndamento: false,

      loadingOfferte: false,
      loadingSubagenti: false,
      loadingTreeSubagenti: false,
      loadingTreeSubagentiFlat: false,
      selectedAgent: null,
      selectedAgentName: '',
      selectedAgentKey: '',
      selectedAgentOffers: [],
      validationErrors: {},
      types_error: {
        email: ['isEmail', 'existEmail'],
        network: ['comuneNetwork'],
        address: ['address', 'lat', 'lng']
      },
      submitted: false,

      currencyFormatter: new Intl.NumberFormat('it-IT', {
        style: 'currency',
        currency: 'EUR',
      }),

      route: {
        params: null
      },

      isInEdit: false,
      oldInfo: null,

      offerte: [],
      cities: [],
      selectedOfferte: null,
      agentsTreeFlat: [],
      selectedAgentsTreeFlat: null,
      selectedAgentOfferteTree: [],


      typeAgent: 0,
      typeAgents: [
        { 'val': 0, 'label': 'Agente' },
        { 'val': 1, 'label': 'Subagente' },
        { 'val': 2, 'label': 'Agente con subagenti (Agenzia)' },
        { 'val': 3, 'label': 'Supervisore' },
      ],
      types_state: [
        { prop: 'active', description: 'Attivi' },
        { prop: 'production', description: 'In attivazione' },
        { prop: 'working', description: 'In lavorazione' },
        { prop: 'swout', description: 'In SwitchOut' },
        { prop: 'rendimento', description: 'Previsione' }
      ],
      types_pp: [
        { prop: 'ee', device: 'pod', unit: 'Gwh', img: 'lampadina' },
        { prop: 'gas', device: 'pdr', unit: 'Smca', img: 'fiamma' }
      ],

      frequenze:[
        {id: 1, name: 'Mensile'},
        {id: 2, name: 'Bimestrale'}
      ],

      agenti: [],
      sottoAgenti: [],
      isAgency: false,
      selectedAgenti: [],
      // selectedAgentParent:0,
      agenzie: [],
      selectedAgenzia: 0,

      data: {
        item: {
          id: null,
          info: {
            name: '',
            two_factor_auth: false,
            two_factor: false
          },
          ticket: []
        }
      },
      forceMail: '',
      ccnMail: 'credenziali@agfenergy.it',
      fileToUploadTipo: {
        title: '',
        file: [],
        allowedType: {
          'pdf': 'application/pdf'
        },
        allowedExtensions: ['pdf']
      },
      tipiDocumentoModulistica: [
        { id: 'man', code: 'man', name: 'MANDATO', isAltro: false },
        { id: 'altro', code: 'altro', name: 'ALTRO', isAltro: true },
      ],
      selectedTipoDocumento: null,
      submittedTipo: false,
      validationErrorsTipo: {},
      chartData: null,
      chartOptions: null,
      scaglioni: {},
      gettoni: [],
      new_scaglione: {
        min: {
          value: 1,
          min: 1,
          max: null
        },
        max: {
          value: null,
          min: null,
          max: null
        }
      },
      toast: useToast(),
      isNullMaxNewScaglione: false,
      visibleDialogNewScaglione: false,
      editingRows: {},
      periodi_gettone: [
        { label: 'gettone non previsto', value: null },
        { label: 15, value: 15 },
        { label: 45, value: 45 },
        { label: 75, value: 75 }
      ],
      types_storno: [
        { label: 'Nessuno storno', value: null },
        { label: 'Parziale', value: 1 },
        { label: 'Totale', value: 2 }
      ],
      mesi_storno: [
        { label: "Nessun mese", value: null },
        { label: 1 ,value: 1 },
        { label: 2 ,value: 2 },
        { label: 3 ,value: 3 },
        { label: 4 ,value: 4 },
        { label: 5 ,value: 5 },
        { label: 6 ,value: 6 },
        { label: 7 ,value: 7 },
        { label: 8 ,value: 8 },
        { label: 9 ,value: 9 },
        { label: 10,value: 10 },
        { label: 11,value: 11 },
        { label: 12,value: 12 }
      ],
      filters_offerta_gettone: {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        offerta: { value: null, matchMode: FilterMatchMode.CONTAINS }
      },
      fattureAperte: {
        id_agente: null,
        nome_agente: null,
        email_agente: null,
        totale_scoperto: 0,
        numero_fatture: 0,
        dettaglio_fatture: []
      },
      visibleDialogCloneOfferteFromOtherAgent: false,
      offerteClone: [],
      selectedAgentForCloneOfferte: null,
      modelfilterAgente: null,
      filterAgente: [],
      filteredFatture: [],
      gruppi: [],
      selectedAnno: null,
      provvigioni: {
        monthly_totals: {},
        fatture_details: []
      },
      anniDisponibili: []
    }
  },

  created() {
    this.route.params = this.$route.params
    this.data.item.id = this.route.params?.id
    this.agentiService = new AgentiService(this.$http, this.$eventBus)
    this.utilityService = new UtilityService(this.$http, this.$eventBus)
    this.getCities()
    this.getDettaglioAgente(this.route.params.id)
    this.getAndamento(this.route.params.id)
    // this.getListaOfferte()
    this.getOfferte(this.route.params.id)
    this.getSubagenti(this.route.params.id)
    this.getTreeSubagenti(this.route.params.id)
    this.getTreeSubagentiFlat(this.route.params.id)
    this.getScaglioni(this.route.params.id)
    this.getGettoni(this.route.params.id)
    this.getListaAgenti()
    this.getListaAgenzie()
    this.formatDate = getCurrentInstance().appContext.config.globalProperties.$formatDate;
    this.getFattureAperte(this.route.params.id)
    this.getAnniDisponibili()
  },

  methods: {
    showOffers(agent) {
      this.selectedAgent = agent;
      this.selectedAgentName = agent.name;
      this.selectedAgentKey = agent.key;
      this.selectedAgentOffers = agent.offerte;
      this.dialogVisible = true;
    },
    formatOfferSpread(offerta) {
      if (!offerta) return '--';
      if (offerta.spread !== undefined && offerta.spread !== null && offerta.spread !== '') {
        return offerta.spread;
      }
      const tariff = Number(offerta.cod_type_tariffazione);
      let value = null;
      if (tariff === 1) {
        value = offerta.m;
      } else if (tariff === 3) {
        value = offerta.f1;
      } else {
        value = Number(offerta.m) ? offerta.m : offerta.f1;
      }
      return value === null || value === undefined || value === '' ? '--' : value;
    },
    formatOfferPcv(offerta) {
      if (!offerta || offerta.pcv === null || offerta.pcv === undefined || offerta.pcv === '') {
        return '--';
      }
      return offerta.pcv;
    },
    closeDialog() {
      this.dialogVisible = false;
      this.selectedAgent = null;
      this.selectedAgentOffers = [];
    },
    initializeAgents() {
      if (this.data.item.tree_subagenti) {
        this.data.item.tree_subagenti.forEach(agent => {
          if (agent.children) {
            agent.children.forEach(subAgent => {
              subAgent.showSubagents = false;
            });
          }
        });
      }
    },
    created() {
      this.initializeAgents();
    },
    selectAgent(agent) {
      this.selectedAgent = agent;
    },
    async getDettaglioAgente(id) {
      this.loader = true
      const agentId = id || this.route.params?.id || this.$route?.params?.id
      this.agentiService.getDettaglioAgente(agentId)
      .then((res) => {
        this.data.item = {
          ...this.data.item,
          ...(res.item || {})
        }
        this.data.item.id = this.data.item.id || this.data.item.info?.id || agentId
        if (!this.data.item.info) {
          this.data.item.info = {
            name: '',
            two_factor_auth: false,
            two_factor: false
          }
        }
        this.convertCanViewInBoolean()
        this.agentiService.getTwoFactorAuth(agentId).then((isOtp) => {
          if (this.data?.item?.info) {
            this.data.item.info.two_factor_auth = Boolean(isOtp);
            this.data.item.info.two_factor = Boolean(isOtp);
          }
        });

        // this.getTypeAgent()
        // title page browser
        let title = document.title.split("-")[0] + " - " + document.title.split("-")[1];
        document.title = 'info' in this.data.item ? ('name' in this.data.item.info ? title + " - " + this.data.item.info.name : title) : title
      })
      .finally(() => {
        this.loader = false
      })
    },
    getAndamento(id){
      this.loadingAndamento = true
      this.loadedAndamento = false
      this.agentiService.getAndamentoAgente(id)
      .then((res) => {
        if ('andamento' in res.item && 'report_forniture' in res.item){
          this.data.item.andamento = res.item.andamento
          this.data.item.report_forniture = res.item.report_forniture
          this.chartData = this.setChartData();
          this.chartOptions = this.setChartOptions();
          this.loadedAndamento = true
        }
      })
      .finally(()=>{
        this.loadingAndamento = false
      })
    },
    getOfferte(id){
      this.loadingOfferte = true
      this.agentiService.getOfferteAgente(id)
      .then((res) => {
        this.data.item.offerte = res.item.offerte
      })
      .finally(()=>{
        this.loadingOfferte = false
      })
    },
    getSubagenti(id){
      this.loadingSubagenti = true
      this.agentiService.getSubagentiAgente(id)
      .then((res) => {
        this.data.item.subagenti = res.item.subagenti
      })
      .finally(()=>{
        this.loadingSubagenti = false
      })
    },
    getTreeSubagenti(id){
      this.loadingTreeSubagenti = true
      this.agentiService.getTreeSubagentiAgente(id)
      .then((res) => {
        this.data.item.tree_subagenti = res.item.tree_subagenti
      })
      .then(()=>{
        if (this.data.item.tree_subagenti) {
          const addExpanded = (agents) => {
            return agents.map(agent => ({
              ...agent,
              expanded: false,
              children: agent.children ? addExpanded(agent.children) : []
            }));
          };
          this.data.item.tree_subagenti = addExpanded(this.data.item.tree_subagenti);
          if ('tree_subagenti' in this.data.item) {
            this.data.item.tree_subagenti[0].offerte.forEach(offerta => {
              offerta.duplicabile = !!offerta.duplicabile
            })
          }
        }

        this.populateSelectedAgentOfferteTree()
      })
      .finally(()=>{
        this.loadingTreeSubagenti = false
      })
    },
    getTreeSubagentiFlat(id){
      this.loadingTreeSubagentiFlat = true
      this.agentiService.getTreeSubagentiFlatAgente(id)
      .then((res) => {
        this.data.item.tree_subagenti_flat = res.item.tree_subagenti_flat
      })
      .then(()=>{
        this.populateAgentsTreeFlat()
      })
      .finally(()=>{
        this.loadingTreeSubagentiFlat = false
      })
    },
    async getCities() {
      this.agentiService.getCities()
        .then((res) => {
          this.cities = res.items
        })
    },
    populateAgentsTreeFlat() {
      if ('tree_subagenti_flat' in this.data.item) {
        this.agentsTreeFlat = this.data.item.tree_subagenti_flat
      }
    },

    populateSelectedAgentOfferteTree() {
      if ('tree_subagenti' in this.data.item) {
        let arrayDiOggetti = this.data.item.tree_subagenti
        this.loopObjChildrenTree(arrayDiOggetti);
      }
    },

    loopObjChildrenTree(array) {
      array.forEach(obj => {
        this.selectedAgentOfferteTree[obj.key] = [];
        obj.offerte.forEach(offerta => {
          if (!('parent' in offerta) || offerta.parent == 0) {
            this.selectedAgentOfferteTree[obj.key].push(offerta)
          }
        });

        if (obj.children && obj.children.length > 0) {
          this.loopObjChildrenTree(obj.children);
        }
      });
    },

    applyNewGroupOfferteToAgent(item) {
      this.loader = true
      let offerte = this.selectedAgentOfferteTree[item.key];
      this.agentiService.applyNewGroupOfferteToAgent(item,offerte)
      .then((res) => {
        if (res.success) {
          this.getDettaglioAgente(this.data.item.id)
        } else {
          this.$toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore aggiornamento offerte', life: 3000 });
        }
      })
      .finally(() => {
        this.loader = false
      })
    },

    getListaOfferte() {
      this.utilityService.getListaOfferte()
        .then((res) => {
          this.offerte = res.items
        })
        .then(() => {
          // remove offerte già associate
          //this.offerte = this.offerte.filter(obj1 => !this.data.item.offerte.some(obj2 => obj2.id === obj1.id));
        })
    },
    searchOfferta(event){
      if (event.query.length > 4) {
        this.utilityService.getSearchedOfferta(event.query)
        .then((res) => {
          this.offerte = res.items
        })
      }
    },
    getListaAgenzie() {
      this.utilityService.getAgenzie()
        .then((res) => {
          this.agenzie = res.items
        })
        .then(() => {
          if ('id_parent' in this.data.item.info && this.data.item.info.id_parent) {
            this.selectedAgenzia = this.data.item.info.id_parent
          }

        })
    },

    getListaAgenti() {
      this.utilityService.getAgenti()
        .then((res) => {
          this.agenti = res.items.filter(item => item.id != this.route.params.id)
        })
    },

    convertCanViewInBoolean() {
      if ('info' in this.data.item) {
        this.data.item.info.has_subagents = !!this.data.item.info.has_subagents
        this.data.item.info.is_point = Boolean(this.data.item.info.is_point)
        this.data.item.info.is_point_diretto = Boolean(this.data.item.info.is_point_diretto)
        this.data.item.info.notificaSwitchout = Boolean(this.data.item.info.notificaSwitchout)
        this.data.item.info.notificaStorni = Boolean(this.data.item.info.notificaStorni)
        this.data.item.info.notificaPreavvisi = Boolean(this.data.item.info.notificaPreavvisi)
        this.data.item.info.can_view_simulator = Boolean(this.data.item.info.can_view_simulator)
        this.data.item.info.can_select_bimestrale = Boolean(this.data.item.info.can_select_bimestrale)
        this.data.item.info.show_map = Boolean(this.data.item.info.show_map)
        this.data.item.info.two_factor_auth = Boolean(
          this.data.item.info.two_factor_auth ?? this.data.item.info.two_factor ?? false
        )
        this.data.item.info.two_factor = this.data.item.info.two_factor_auth

        this.data.item.info.can_view_offer = !!this.data.item.info.can_view_offer
        this.data.item.info.can_view_offer_name = !!this.data.item.info.can_view_offer_name
        // this.data.item.info.can_view_commission = !!this.data.item.info.can_view_commission
        // this.data.item.info.can_calculate_commission = !!this.data.item.info.can_calculate_commission
        // this.data.item.info.can_view_as = !!this.data.item.info.can_view_as
        this.data.item.info.can_view_autolettura = !!this.data.item.info.can_view_autolettura
        this.data.item.info.can_view_conguaglio = !!this.data.item.info.can_view_conguaglio
        this.data.item.info.can_view_offer_generation = !!this.data.item.info.can_view_offer_generation
      }
      if ('tree_subagenti' in this.data.item) {
        this.data.item.tree_subagenti[0].offerte.forEach(offerta => {
          offerta.duplicabile = !!offerta.duplicabile
        })
      }
    },
    showDialogNewScaglione(){      
      if (this.gruppi.length == 1) this.changeGruppo(1) 
      this.visibleDialogNewScaglione = true
    },
    // getTypeAgent () {
    //   if (this.data.item.info.id_parent) {
    //       this.typeAgent = 1;
    //   } else if (this.data.item.info.has_subagents) {
    //       this.typeAgent = 2;
    //   } else if (this.data.item.info.is_supervisor) {
    //       this.typeAgent = 3;
    //   } 
    // },

    sendAgentLoginEmail() {
      this.submitted = true;
      let mail = this.forceMail != '' ? this.forceMail : this.data.item.info.email
      if (this.validateMail(mail)) {
        this.loader = true
        this.agentiService.sendAgentLoginEmail(
          this.data.item.info.name,
          this.data.item.info.email,
          'agf',
          this.forceMail,
          this.ccnMail
        )
          .then((res) => {
            if (res.success) {
              this.$toast.add({ severity: 'success', summary: 'Successo', detail: 'Email inviata', life: 3000 });
              this.updateAgentiAccessDate()
            } else {
              this.$toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore nell\'invio della email', life: 3000 });
            }
          })
          .finally(() => {
            this.loader = false
          })
      }

    },

    updateAgentiAccessDate() {
      this.loader = true
      this.agentiService.updateAgentiAccessDate(
        this.data.item.info.email,
      )
        .then((res) => {
          if (res.success) {
            this.getDettaglioAgente(this.data.item.id)
          } else {
            this.$toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore update dati accesso', life: 3000 });
          }
        })
        .finally(() => {
          this.loader = false
        })
    },

    changeCanView() {
      this.loader = true
      let data = {...this.data.item.info}
      data.id = this.data.item.id
      
      this.agentiService.changeAgenteCanView(data)
      .then((res) => {
        if (res.success) {
          this.$toast.add({ severity: 'success', summary: 'Successo', detail: 'Visibiltà cambiate', life: 3000 });
        } else {
          this.$toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore nella modifica', life: 3000 });
        }
      })
      .finally(() => {
        this.loader = false
      })
    },

    onToggleTwoFactorAuth() {
      const isEnabled = Boolean(this.data.item.info.two_factor_auth);
      const previousState = !isEnabled;
      const agenteNome = this.data.item.info?.name
        ? ` per l'agente "${this.data.item.info.name}"`
        : ' per questo agente';
      const actionText = isEnabled ? 'attivare' : 'disattivare';
      const headerText = isEnabled
        ? 'Conferma attivazione login OTP'
        : 'Conferma disattivazione login OTP';
      const message = `Sei sicuro di voler ${actionText} il login OTP${agenteNome}?`;

      let hasConfirmed = false;

      const revert = () => {
        this.confirming2fa = false;
        this.data.item.info.two_factor_auth = previousState;
        this.data.item.info.two_factor = previousState;
      };

      this.confirming2fa = true;

      if (this.$confirm?.require) {
        this.$confirm.require({
          group: 'agente-otp',
          header: headerText,
          message: message,
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: isEnabled ? 'Attiva' : 'Disattiva',
          rejectLabel: 'Annulla',
          acceptClass: isEnabled ? 'p-button-primary' : 'p-button-danger',
          accept: () => {
            hasConfirmed = true;
            this.confirming2fa = false;
            this.executeToggleTwoFactorAuth(isEnabled);
          },
          reject: () => {
            revert();
          },
          onHide: () => {
            if (!hasConfirmed) {
              revert();
            }
          }
        });
        return;
      }

      if (window.confirm(message)) {
        this.confirming2fa = false;
        this.executeToggleTwoFactorAuth(isEnabled);
      } else {
        revert();
      }
    },

    async executeToggleTwoFactorAuth(isEnabled) {
      this.data.item.info.two_factor_auth = isEnabled;
      this.data.item.info.two_factor = isEnabled;
      this.loading2fa = true;

      const agentId = this.data.item.id || this.data.item.info?.id || this.route.params?.id;
      try {
        const res = await this.agentiService.updateTwoFactorAuth(agentId, isEnabled);
        if (res.success) {
          this.$toast.add({
            severity: 'success',
            summary: 'Successo',
            detail: isEnabled
              ? 'Login OTP attivato con successo'
              : 'Login OTP disattivato con successo',
            life: 3000
          });
        } else {
          this.data.item.info.two_factor_auth = !isEnabled;
          this.data.item.info.two_factor = !isEnabled;
          this.$toast.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Impossibile aggiornare il login OTP',
            life: 3000
          });
        }
      } catch (err) {
        this.data.item.info.two_factor_auth = !isEnabled;
        this.data.item.info.two_factor = !isEnabled;
        this.$toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Errore durante l\'aggiornamento del login OTP',
          life: 3000
        });
      } finally {
        this.loading2fa = false;
      }
    },

    handleFileUploadTipo(evt) {
      evt.preventDefault()
      this.submittedTipo = false;
      let files = this.$refs.fileTipo?.files?.length
        ? Array.from(this.$refs.fileTipo.files)
        : []
      // Mandato: un solo PDF
      if (!this.isTipoAltro && files.length > 1) {
        files = [files[0]]
      }
      this.fileToUploadTipo.file = files
    },

    isAllowedUploadFile(file, config) {
      const mimeOk = Object.values(config.allowedType || {}).includes(file.type)
      const ext = (file.name || '').split('.').pop()?.toLowerCase()
      const extOk = (config.allowedExtensions || []).includes(ext)
      return mimeOk || extOk
    },

    onTipoDocumentoChange() {
      this.fileToUploadTipo.file = []
      this.resetFileInput('fileTipo')
      if (this.isTipoAltro) {
        this.fileToUploadTipo.title = ''
      } else {
        this.fileToUploadTipo.title = this.selectedTipoDocumento?.name || 'MANDATO'
      }
      if (this.submittedTipo) {
        this.validateUploadTipo()
      }
    },

    prependModulo(documentoOrList) {
      const incoming = Array.isArray(documentoOrList)
        ? documentoOrList
        : (documentoOrList ? [documentoOrList] : [])
      if (!incoming.length) return
      const list = Array.isArray(this.data.item.modulistica) ? [...this.data.item.modulistica] : []
      incoming.slice().reverse().forEach((documento) => {
        if (!list.some((m) => m.codice === documento.codice)) {
          list.unshift(documento)
        }
      })
      this.data.item.modulistica = list
    },

    async refreshModulistica() {
      const res = await this.agentiService.getDettaglioAgente(this.data.item.id)
      if (res.item && Array.isArray(res.item.modulistica)) {
        this.data.item.modulistica = res.item.modulistica
      }
    },

    resetFileInput(refName) {
      if (this.$refs[refName]) {
        this.$refs[refName].value = ''
      }
    },

    async uploadModuloTipo() {
      this.submittedTipo = true;
      if (!this.validateUploadTipo()) return

      this.loader = true
      try {
        const payload = {
          ...this.fileToUploadTipo,
          title: this.isTipoAltro
            ? this.fileToUploadTipo.title
            : (this.selectedTipoDocumento?.name || 'MANDATO'),
        }
        // forceAdmin: sempre documenti_admin da questa UI
        const res = await this.agentiService.uploadModulo(payload, this.data.item.id, 0, true)
        if (res.items.success) {
          this.prependModulo(res.items.documenti?.length ? res.items.documenti : res.items.documento)
          this.fileToUploadTipo.title = ''
          this.fileToUploadTipo.file = []
          this.selectedTipoDocumento = null
          this.resetFileInput('fileTipo')
          this.submittedTipo = false
          await this.refreshModulistica()
          this.$toast.add({ severity: 'success', summary: 'Successo', detail: res.items.msg, life: 3000 });
        } else {
          this.$toast.add({ severity: 'error', summary: 'Errore', detail: res.items.msg, life: 3000 });
        }
      } finally {
        this.loader = false
      }
    },

    downloadModulo(modulo) {
      this.loader = true
      this.agentiService.downloadAgenteModulo(
        modulo.codice,
      )
        .finally(() => {
          this.loader = false
        })
    },

    async deleteModulo(modulo) {
      this.loader = true
      try {
        const res = await this.agentiService.deleteAgenteModulo(modulo.codice)
        if (res.success) {
          const list = Array.isArray(this.data.item.modulistica) ? this.data.item.modulistica : []
          this.data.item.modulistica = list.filter((m) => m.codice !== modulo.codice)
          await this.refreshModulistica()
          this.$toast.add({ severity: 'success', summary: 'Successo', detail: 'Eliminato', life: 3000 });
        } else {
          this.$toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore', life: 3000 });
        }
      } finally {
        this.loader = false
      }
    },
    associateOfferte() {
      this.loader = true
      this.agentiService.associateAgenteOfferte(
        this.selectedAgentsTreeFlat.map(el =>{
          return el.id
        }),
        this.selectedOfferte.map(el =>{
          return el.id
        })
      )
      .then((res) => {
        if (res.success) {
          this.getDettaglioAgente(this.data.item.id)
          this.selectedOfferte = null
          this.selectedAgentsTreeFlat = []
          this.$toast.add({ severity: 'success', summary: 'Successo', detail: 'Associazione avvenuta', life: 3000 });
        } else {
          this.$toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore', life: 3000 });
        }
      })
      .finally(() => {
        this.loader = false
      })
    },
    associateOfferteToAllSubagents() {
      let id = this.selectedAgentsTreeFlat[0].id
      let tree = this.data.item.tree_subagenti
      let startingAgent = this.findObjectById(id, tree)
      let subagentsArray = this.findAllSubagents(startingAgent);
      this.selectedAgentsTreeFlat = subagentsArray
      this.associateOfferte()
    },
    dissociateOfferteToAllSubagents() {
      let id = this.selectedAgentsTreeFlat[0].id
      let tree = this.data.item.tree_subagenti
      let startingAgent = this.findObjectById(id, tree)
      let subagentsArray = this.findAllSubagents(startingAgent);
      this.selectedAgentsTreeFlat = subagentsArray
      this.dissociateOfferte()
    },
    findObjectById(id, tree) {
      for (const obj of tree) {
        if (obj.id === id) {
          return obj;
        }

        if (obj.children && obj.children.length > 0) {
          const foundInChildren = this.findObjectById(id, obj.children);
          if (foundInChildren) {
            return foundInChildren;
          }
        }
      }

      return null;
    },
    findAllSubagents(agent, subagents = []) {
      subagents.push(agent);

      if (agent.children && agent.children.length > 0) {
        agent.children.forEach((child) => {
          this.findAllSubagents(child, subagents);
        });
      }

      return subagents;
    },
    dissociateOfferte() {
      this.loader = true
      const ids_agenti = this.selectedAgentsTreeFlat.map(agente => {
        return agente.id
      })

      const ids_offerte = this.selectedOfferte.map(offerta => {
        return offerta.id
      })

      this.agentiService.dissociateAgenteOfferte({ids_agenti, ids_offerte})
        .then((res) => {
          if (res.success) {
            this.getDettaglioAgente(this.data.item.id)
            this.selectedOfferte = null
            this.selectedAgentsTreeFlat = []
            this.$toast.add({ severity: 'success', summary: 'Successo', detail: 'Dissociazione avvenuta', life: 3000 });
          } else {
            this.$toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore', life: 3000 });
          }
        })
        .finally(() => {
          this.loader = false
        })
    },
    associateAgencyToAgent() {
      this.loader = true
      this.agentiService.associateAgencyToAgent(
        this.data.item.id,
        this.data.item.info.id_parent,
        // this.selectedAgentParent
      )
        .then((res) => {
          if (res.success) {
            this.getDettaglioAgente(this.data.item.id)
            this.$toast.add({ severity: 'success', summary: 'Successo', detail: 'Agenzia associata', life: 3000 });
          } else {
            this.$toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore', life: 3000 });
          }
        })
        .finally(() => {
          this.loader = false
        })
    },
    associateSubagentsToAgent() {
      this.loader = true
      this.agentiService.associateSubagentsToAgent(
        this.data.item.id,
        this.selectedAgenti
      )
        .then((res) => {
          if (res.success) {
            this.getDettaglioAgente(this.data.item.id)
            this.$toast.add({ severity: 'success', summary: 'Successo', detail: 'Subagenti associati', life: 3000 });
          } else {
            this.$toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore', life: 3000 });
          }
        })
        .finally(() => {
          this.loader = false
        })
    },

    dissociateSubagenti(subagente) {
      this.loader = true
      this.agentiService.dissociateSubagenti(
        this.data.item.id,
        subagente
      )
        .then((res) => {
          if (res.success) {
            this.getDettaglioAgente(this.data.item.id)
            this.$toast.add({ severity: 'success', summary: 'Successo', detail: 'Dissociazione avvenuta', life: 3000 });
          } else {
            this.$toast.add({ severity: 'error', summary: 'Errore', detail: 'Errore', life: 3000 });
          }
        })
        .finally(() => {
          this.loader = false
        })
    },

    validateMail(mail) {
      let regex_email = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      this.validationErrors = {}

      if (regex_email.test(mail))
        delete this.validationErrors['isEmail'];
      else
        this.validationErrors['isEmail'] = true;

      return !Object.keys(this.validationErrors).length;
    },
    validateExistMail(mail) {
      this.validationErrors = {}

      if (this.agenti.some(agente => agente.email == mail))
        this.validationErrors['existEmail'] = true;
      else
        delete this.validationErrors['existEmail'];

      return !Object.keys(this.validationErrors).length;
    },
    validateUploadTipo() {
      this.validationErrorsTipo = {}

      if (!this.selectedTipoDocumento)
        this.validationErrorsTipo['tipo'] = true;
      else
        delete this.validationErrorsTipo['tipo'];

      if (this.isTipoAltro) {
        if (!String(this.fileToUploadTipo.title || '').trim())
          this.validationErrorsTipo['title'] = true;
        else
          delete this.validationErrorsTipo['title'];
      } else {
        delete this.validationErrorsTipo['title'];
      }

      if (this.fileToUploadTipo.file.length == 0) {
        this.validationErrorsTipo['files'] = true;
        delete this.validationErrorsTipo['type'];
      } else {
        delete this.validationErrorsTipo['files'];
      }

      if (this.fileToUploadTipo.file.length > 0 && !this.isTipoAltro) {
        const valid = this.fileToUploadTipo.file.every((file) => this.isAllowedUploadFile(file, this.fileToUploadTipo));
        if (valid)
          delete this.validationErrorsTipo['type'];
        else
          this.validationErrorsTipo['type'] = true;
      } else {
        delete this.validationErrorsTipo['type'];
      }

      return !Object.keys(this.validationErrorsTipo).length;
    },
    validateComuneNetwork() {
      this.validationErrors = {}

      if (this.data.item.info.is_point_diretto && !this.data.item.info.cod_comune_network)
        this.validationErrors['comuneNetwork'] = true;
      else
        delete this.validationErrors['comuneNetwork'];

      return !Object.keys(this.validationErrors).length;
    },
    validateAddress() {
      this.validationErrors = {}
      let checks = this.types_error.address
      let result_check = {}
      checks.forEach(check => {
        result_check[check] = ['', null].includes(this.data.item.info[check])
      })
      if (this.data.item.info.show_map) {
        Object.keys(result_check).forEach(res => {
          if (result_check[res]) {
            this.validationErrors[res] = true;
          }
        })
      } else {
        Object.keys(result_check).forEach(res => {
          delete this.validationErrors[res];
        })
      }
      return !Object.keys(this.validationErrors).length;
    },
    removeErrors(type_data) {
      let array_errors = this.types_error[type_data]
      array_errors.forEach(error => {
        delete this.validationErrors[error]
      })
    },
    changeIsPointDiretto() {
      this.data.item.info.cod_comune_network = null
      this.removeErrors('network')
    },
    changeShowMap() {
      this.data.item.info.lat = null
      this.data.item.info.lng = null
      this.data.item.info.address = null
      this.removeErrors('address')
    },
    formatCurrency(value) {
      return value.toLocaleString('it-IT', { style: 'currency', currency: 'EUR' });
    },

    onEditInfo() {
      this.oldInfo = JSON.stringify(this.data.item.info)

      this.isInEdit = !this.isInEdit
    },

    onAbortInfoEdit() {
      this.data.item.info = JSON.parse(this.oldInfo)

      // this.oldInfo = null
      this.isInEdit = !this.isInEdit
    },

    onUpdateInfo() {
      const allowed = [
        'name', 'email', 'telefono', 'partita_iva', 'is_point', 'is_point_diretto', 'notificaSwitchout', 'notificaStorni', 'notificaPreavvisi', 'can_view_simulator', 'can_select_bimestrale', 'cod_comune_network', 'show_map', 'address', 'lat', 'lng', 'gettone_periodo', 'default_type_periodo', 'gettone_rid', 'gettone_tipo_storno', 'gettone_mesi_storno', 'two_factor_auth', 'two_factor'
      ]

      const info = Object.keys(this.data.item.info)
        .filter(key => allowed.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: this.data.item.info[key]
          };
        }, {})

      if (this.validateAddress()) {
        if (this.validateComuneNetwork()) {
          if (this.validateMail(info.email) && this.validateExistMail(info.email)) {
            if (this.oldInfo != JSON.stringify(this.data.item.info)) {
              this.loader = true
              this.agentiService.updateInfo(this.data.item.id, info).then((res) => {
                if (res.success) {
                  delete res.item.id

                  this.data.item.info = res.item
                  this.convertCanViewInBoolean()
                }
              })
                .finally(() => {
                  this.loader = false
                })
            }

            this.oldInfo = null
            this.isInEdit = !this.isInEdit
          }
        }
      }
    },
    setLabels(data) {
      let months = [
        { id: 1, name: 'Gennaio' },
        { id: 2, name: 'Febbraio' },
        { id: 3, name: 'Marzo' },
        { id: 4, name: 'Aprile' },
        { id: 5, name: 'Maggio' },
        { id: 6, name: 'Giugno' },
        { id: 7, name: 'Luglio' },
        { id: 8, name: 'Agosto' },
        { id: 9, name: 'Settembre' },
        { id: 10, name: 'Ottobre' },
        { id: 11, name: 'Novembre' },
        { id: 12, name: 'Dicembre' }
      ]
      let labels = []
      data.forEach(item => {
        let name_month = months.find(month => month.id == item.mese).name
        labels.push(`${name_month} ${item.anno}`)
      })
      return labels
    },
    setDataChars(data, type_data) {
      let res = []
      data.forEach(item => {
        res.push(item[`totale${type_data}`])
      })
      return res
    },
    setChartData() {
      const documentStyle = getComputedStyle(document.documentElement);
      return {
        labels: this.setLabels(this.data.item.andamento.report),
        datasets: [
          {
            type: 'bar',
            label: 'Fatturato',
            backgroundColor: documentStyle.getPropertyValue('--green-500'),
            data: this.setDataChars(this.data.item.andamento.report, 'Fatturato')
          },
          // {
          //   type: 'bar',
          //   label: 'Pagato',
          //   backgroundColor: documentStyle.getPropertyValue('--gray-500'),
          //   data: this.setDataChars(this.data.item.andamento.report, 'Pagato')
          // },
          {
            type: 'bar',
            label: 'Insoluto',
            backgroundColor: documentStyle.getPropertyValue('--pink-700'),
            data: this.setDataChars(this.data.item.andamento.report, 'Insoluto')
          }
        ]
      };
    },
    setChartOptions() {
      const documentStyle = getComputedStyle(document.documentElement);
      const textColor = documentStyle.getPropertyValue('--text-color');
      const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
      const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

      return {
        maintainAspectRatio: false,
        aspectRatio: 0.8,
        plugins: {
          tooltips: {
            mode: 'index',
            intersect: false
          },
          legend: {
            labels: {
              color: textColor
            }
          }
        },
        scales: {
          x: {
            stacked: true,
            ticks: {
              color: textColorSecondary
            },
            grid: {
              color: surfaceBorder
            }
          },
          y: {
            stacked: true,
            ticks: {
              color: textColorSecondary
            },
            grid: {
              color: surfaceBorder
            }
          }
        }
      };
    },
    async getGettoni(id) {
      this.agentiService.getGettoni(id)
        .then((res) => {
          this.gettoni = res.items
          Object.keys(this.gettoni || {}).forEach(n_gruppo => {
            if (!this.editingRows[n_gruppo]) {
              this.editingRows[n_gruppo] = []
            }
          })
        })
    },
    async getScaglioni(id) {
      this.scaglioni = {}
      this.agentiService.getScaglioni(id)
        .then((res) => {
          this.scaglioni = {}
          if (res.items.length > 0) {
            let gruppi = []
            res.items.forEach(item => {
              if(!this.scaglioni[item.gruppo]){
                this.scaglioni[item.gruppo] = []
              }
              this.scaglioni[item.gruppo].push(item)
              gruppi.push(item.gruppo)
            })
            gruppi = [...new Set(gruppi)].sort((a, b) => a - b);            
            this.gruppi = gruppi.map(gruppo => ({
              id: gruppo,
              value: gruppo,
              disabled: false
            }))
          }
          let next_gruppo = 1
          if (this.gruppi.length > 0) {
           next_gruppo  = this.gruppi[this.gruppi.length-1].id+1
          }
          this.gruppi.push({id: next_gruppo, value: next_gruppo, disabled: false})
          Object.keys(this.scaglioni).forEach(n_gruppo => {
            if (!this.editingRows[n_gruppo]) {
              this.editingRows[n_gruppo] = []
            }
            this.scaglioni[n_gruppo].forEach(scaglione => {
              let disabled = false
              if (!scaglione.max) {
                disabled = true
              }
              let index_gruppo = this.gruppi.findIndex(gruppo => gruppo.id == n_gruppo)
              this.gruppi[index_gruppo].disabled = disabled
            })
          })
        })
    },
    resetNewScaglione() {
      this.new_scaglione = {
        min: {
          value: 1,
          min: 1,
          max: null
        },
        max: {
          value: null,
          min: null,
          max: null
        }
      }
    },
    saveNewScaglione() {
      this.visibleDialogNewScaglione = false
      this.loader = true
      this.agentiService.saveNewScaglione(this.route.params.id, this.new_scaglione)
        .then((res) => {
          let severity = res.items.success ? 'success' : 'warn'
          let detail = res.items.msg
          this.toast.add({ severity: severity, detail: detail, life: 5000 })
          this.getGettoni(this.route.params.id)
          this.getScaglioni(this.route.params.id)
          this.resetNewScaglione()
        })
        .finally(() => {
          this.loader = false
        })
    },
    resetMaxNewScaglione() {
      this.new_scaglione.max = {
        value: null,
        min: null,
        max: null
      }
    },
    async onRowEditSave(event, n_gruppo) {
      let { data, newData } = event;
      let index = this.gettoni[n_gruppo].findIndex(offerte => offerte.id_offerta == data.id_offerta)
      let count_gettoni = 0
      if (JSON.stringify(data) != JSON.stringify(newData)) {
        let new_gettoni_offerta = {
          id_agente: this.route.params.id,
          id_offerta: this.gettoni[n_gruppo][index].id_offerta,
          gettoni: [],
          gruppo: n_gruppo,
          storno: newData.storno
        }
        this.scaglioni[n_gruppo].forEach(scaglione => {
          if (newData[scaglione.label] > 0) count_gettoni++
          let value_scaglione = newData[scaglione.label]
          let obj_gettone = {
            id: scaglione.id,
            value: value_scaglione
          }
          new_gettoni_offerta.gettoni.push(obj_gettone)
        });
        if (newData.storno && this.data.item.info.gettone_tipo_storno == null && this.data.item.info.gettone_mesi_storno == null) {
          new_gettoni_offerta.storno = false
          this.toast.add({ severity: 'warn', detail: 'Non è possibile inserire uno storno senza aggiungere un tipo e/o i mesi di storno validi per l\'agente', life: 5000 })

        }
        if (new_gettoni_offerta.gettoni.length) {
          await this.agentiService.saveGettoni(new_gettoni_offerta)
          .then((res) => {
            if (res.items.success) this.gettoni[n_gruppo][index] = newData;
            let severity
            let detail
            if (newData.storno && count_gettoni == 0) {
              severity = 'warn'
              detail = 'Non è possibile inserire uno storno a gettoni vuoti'
            }else{
              severity = res.items.success ? 'success' : 'warn'
              detail = res.items.msg
            }
            if (count_gettoni == 0 || this.data.item.info.gettone_tipo_storno == null || this.data.item.info.gettone_mesi_storno == null) {
              this.gettoni[n_gruppo][index].storno = false
            }
            this.toast.add({ severity: severity, detail: detail, life: 5000 })
          
          })
        }else{
          this.toast.add({ severity: 'warn', detail: 'Non è possibile salvare gettoni vuoti', life: 5000 })
        }
      }
  },
    customfilterCallback(evt, chip_removed = false){
      if (typeof evt == 'object') {
        let index_el = this.filterAgente.findIndex(el => el == evt.name)
        if (index_el != -1) {
          this.filterAgente.splice(index_el,1)
        } else {
          this.filterAgente.push(evt.name)
        }

        if (this.filterAgente.length > 0) {
          this.filteredFatture = this.fattureAperte.dettaglio_fatture.filter( ft => this.filterAgente.includes(ft.agente))
        } else {
          this.filteredFatture = [...this.fattureAperte.dettaglio_fatture]
        }
      }
      if (chip_removed) {
        delete this.modelfilterAgente[evt.key]
      }
    },
    async getFattureAperte(id) {
      try {
        const response = await this.agentiService.getFattureAperte(id)
        this.fattureAperte = response.items
        this.filteredFatture = [...response.items.dettaglio_fatture]
        this.sottoAgenti = response.items.sottoAgenti.agente        
      } catch (error) {
        console.error('Errore nel recupero delle fatture aperte:', error)
        this.$toast.add({ 
          severity: 'error', 
          summary: 'Errore', 
          detail: 'Errore nel recupero delle fatture aperte', 
          life: 3000 
        })
      }
    },
    openLink(url){
      window.open(`/ask/${url}/dettagli`);
    },
    async getOfferteAgent(idAgente){
      this.loader = true
      this.utilityService.getOfferteAgent(idAgente)
      .then((res) => {
        this.offerteClone = res.items
      })
      .finally(()=>{
        this.loader = false
      })
    },
    async cloneOfferte(){
      let clone = {
        id_agente: this.route.params.id,
        ids_offerte: this.offerteClone.map(offerta => offerta.id)
      }
      this.closeDialogCloneOfferteFromOtherAgente()
      this.loader = true
      await this.agentiService.cloneOfferte(clone)
      .then((res) => {
        let severity = res.items.success ? 'success' : 'warn'
        let detail = res.items.msg
        this.toast.add({severity: severity, detail: detail, life: 8000})
      })
      .finally(()=>{
        this.loader = false
      }) 
    },
    closeDialogCloneOfferteFromOtherAgente() {
      this.visibleDialogCloneOfferteFromOtherAgent = false
      this.selectedAgentForCloneOfferte = null
      this.offerteClone = []
    },
    exportTab(){
      const data = this.filteredFatture.map((item) => ({
        "Agenzia": this.data.item.info.name,
        "Agente firmatario": item.agente,
        "Cliente": item.cliente,
        "Data emissione": moment(item.data_emissione).format('DD/MM/Y'),
        "Data scadenza": moment(item.data_scadenza).format('DD/MM/Y'),
        "Rappresentante": item.rappresentante,
        "Fornitura": item.fornitura,
        "Stato interno fornitura": item.stato_fornitura,
        "Numero Ft": item.numero,
        "Importo totale": item.importo_totale,
        "Importo pagato": item.importo_pagato,
        "Saldo": item.saldo
      }));
      const worksheet = XLSX.utils.json_to_sheet(data);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Fatture aperte");
      XLSX.writeFile(workbook, `Fatture aperte ${this.data.item.info.name}.xlsx`);
    },
    changeGruppo(evt){
      if (this.gruppi.length == 1) this.new_scaglione.gruppo = this.gruppi[0].value
      
      let new_scaglione_min_value = 0
      let new_scaglione_min_min = 0
      let new_scaglione_max_min = 0
      if (this.scaglioni[evt]) {
        let index_last_scaglione = this.scaglioni[evt].length - 1
        if (index_last_scaglione > -1) {
          let last_scaglione = this.scaglioni[evt][index_last_scaglione]
          if (last_scaglione.max) {
            new_scaglione_min_value = last_scaglione.max
            new_scaglione_min_min = last_scaglione.max
            new_scaglione_max_min = last_scaglione.max
          }          
        }        
      }
      this.new_scaglione.min.value = new_scaglione_min_value + 1
      this.new_scaglione.min.min = new_scaglione_min_min + 1
      this.new_scaglione.max.min = new_scaglione_max_min + 2
    },
    getPropMandato(index, prop){
      let typeMandato = [
        {label: 'ARCHIVIATA', class:'bg-red'},
        {label: 'DA MANDATO', class:'bg-blue'}
      ]
      return typeMandato[index][prop]
    },
    rowClass(data){
      return data.duplicabile ? 'bg-warning' : '' ;
    },
    getStatusClass(statusCode) {
      switch (statusCode) {
        case 'open':
          return 'color: #059669; font-weight: 600;';
        case 'in_progress':
          return 'color: #ea580c; font-weight: 600;';
        case 'closed':
          return 'color: #dc2626; font-weight: 600;'; 
        case 'canceled':
          return 'color: #2563eb; font-weight: 600;';
        default:
          return 'color: #6b7280;';
      }
    },
    async getAnniDisponibili() {
      const currentYear = new Date().getFullYear();
      this.anniDisponibili = [];
      for (let year = currentYear; year >= currentYear - 10; year--) {
        this.anniDisponibili.push({
          name: year.toString(),
          value: year
        });
      }
    },
    async cercaProvvigioni() {
      if (!this.selectedAnno) return;
      
      this.loader = true;
      try {
        const response = await this.agentiService.getProvvigioniAgenti(this.data.item.id, this.selectedAnno);
        this.provvigioni = response.items;
      } catch (error) {
        console.error('Errore nel recupero delle provvigioni:', error);
        this.$toast.add({ 
          severity: 'error', 
          summary: 'Errore', 
          detail: 'Errore nel recupero delle provvigioni', 
          life: 3000 
        });
      } finally {
        this.loader = false;
      }
    },
    goToFatturaDetail(idFattura) {
      window.open(`/ask/acquisto/fatture/${idFattura}/dettagli`, '_blank');
    }
  },
  computed: {
    transformedAgentData() {
      const transformNode = (node) => ({
        label: node.name,
        type: 'agent',
        expanded: true,
        data: node,
        children: node.children ? node.children.map(transformNode) : []
      });

      return this.data.item.tree_subagenti.map(transformNode);
    },
    modulisticaList() {
      return Array.isArray(this.data.item?.modulistica) ? this.data.item.modulistica : []
    },
    isTipoAltro() {
      return !!this.selectedTipoDocumento?.isAltro
    },
    fileToUploadTipoLabel() {
      const files = this.fileToUploadTipo.file || []
      if (!files.length) {
        return this.isTipoAltro ? 'Seleziona uno o più file' : 'Seleziona un PDF'
      }
      if (files.length === 1) return files[0].name
      return `${files.length} file selezionati`
    },
    canSaveNewScaglione() {
      let checks = [this.new_scaglione.min.value, this.new_scaglione.gruppo]
      if (!this.isNullMaxNewScaglione) {
        checks.push(this.new_scaglione.max.value)
      }
      return checks.some(check => !check)
    },
    calcolaTotaleComplessivo() {
      if (!this.provvigioni.fatture_details || this.provvigioni.fatture_details.length === 0) {
        return 0;
      }
      return this.provvigioni.fatture_details.reduce((total, detail) => total + detail.totale_fattura, 0);
    },
    calcolaTotaleComplessivoPagato() {
      if (!this.provvigioni.fatture_details || this.provvigioni.fatture_details.length === 0) {
        return 0;
      }
      return this.provvigioni.fatture_details.reduce((total, detail) => total + detail.pagato, 0);
    }
  }
}
</script>
<style>
.input-gettone input {
  width: 60px !important;
}
.bg-warning{
  background-color:rgb(220, 187, 20) !important
}
</style>

<style scoped>
.org-chart-container {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
}

.org-tree {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2rem;
}

.org-level {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  width: 100%;
}

.nested-level {
  animation: slideDown 0.3s ease-out;
}

.subagents-container {
  display: flex;
  gap: 2rem;
  justify-content: center;
  flex-wrap: wrap;
  width: 100%;
  padding: 0 1rem;
}

.org-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 300px;
  overflow: hidden;
  border: 1px solid #e5e7eb;
}

.root-card {
  border-top: 20px solid #3B82F6;
}

.subagent-card {
  border-top: 20px solid #c85a5a;
}

.nested-card {
  border-top: 20px solid #10B981;
}

.card-header {
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.agent-info {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.agent-avatar {
  width: 40px;
  height: 40px;
  background: #f3f4f6;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.agent-details {
  display: flex;
  flex-direction: column;
}

.agent-name {
  font-weight: 600;
  color: #1f2937;
  margin: 0;
  font-size: 0.9rem;
}

.agent-role {
  font-size: 0.75rem;
  color: #6b7280;
}

.card-actions {
  display: flex;
  align-items: center;
  /* gap: 0.5rem; */
}

.offers-badge {
  background: #f3f4f6;
  padding: 0.25rem 0.75rem;
  border-radius: 9999px;
  font-size: 0.75rem;
  color: #4b5563;
}

.connector-line {
  width: 2px;
  height: 2rem;
  background: #e5e7eb;
  margin: 0.5rem 0;
}

.subagent-branch {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.subagent-branch::before {
  content: '';
  position: absolute;
  top: -2rem;
  width: 2px;
  height: 2rem;
  background: #e5e7eb;
}

/* Dialog Styles */
.offers-dialog :deep(.p-dialog-content) {
  padding: 0 1.5rem 1.5rem 1.5rem;
}

.offers-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 1rem;
  max-height: 60vh;
  overflow-y: auto;
  padding: 1rem 0;
}

.offer-card {
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  transition: all 0.2s ease;
}

.offer-card:hover {
  background: #f3f4f6;
  transform: translateY(-2px);
}

.offer-name {
  color: #2563eb;
  text-decoration: none;
  font-size: 0.875rem;
  display: block;
  margin-bottom: 0.25rem;
}

.offer-date {
  font-size: 0.75rem;
  color: #6b7280;
}

.offer-pricing {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-top: 0.35rem;
  font-size: 0.75rem;
  color: #374151;
  font-weight: 500;
}

/* Animazioni */
.org-level {
  animation: slideDown 0.3s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.form-file .button-wrapper {
  position: relative;
  width: 100%;
  text-align: center;
}

.form-file .allowed-format {
  font-size: 12px;
  color: rgb(186, 186, 186);
  margin-top: 2px;
}

.form-file .button-wrapper span.label {
  position: relative;
  z-index: 0;
  display: inline-block;
  width: 100%;
  background: #ffffff;
  border: 1px solid rgb(217, 217, 217) !important;
  cursor: pointer;
  color: rgb(168, 168, 168);
  padding: 10px 2px;
  text-transform: uppercase;
  font-size: 12px;
  border-radius: 3px;
}

.form-file .button-wrapper span.label.active {
  background: #2196F3;
  color: white;
}

.form-file #upload,
.form-file #upload-tipo,
.modulistica-dropzone input[type="file"] {
  display: inline-block;
  position: absolute;
  z-index: 1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

/* Modulistica */
.modulistica-section {
  padding: 0.25rem 0;
}

.modulistica-upload-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 1.25rem;
}

.modulistica-upload-grid--single {
  grid-template-columns: 1fr;
  width: 100%;
}

.modulistica-card {
  border: 1px solid #e8eaed;
  border-radius: 12px;
  background: #fafbfc;
  overflow: hidden;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.modulistica-card:hover {
  border-color: #d0d5dd;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.06);
}

.modulistica-card--accent {
  background: linear-gradient(180deg, #fff8f3 0%, #fafbfc 48%);
  border-color: #f0d9c8;
}

.modulistica-card__head {
  display: flex;
  align-items: flex-start;
  gap: 0.85rem;
  padding: 1.1rem 1.15rem 0.85rem;
  border-bottom: 1px solid #eef0f3;
}

.modulistica-card__icon {
  width: 2.35rem;
  height: 2.35rem;
  border-radius: 10px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef2f6;
  color: #475569;
  flex-shrink: 0;
}

.modulistica-card__icon--accent {
  background: #ffe8d6;
  color: #c2410c;
}

.modulistica-card__title {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 650;
  color: #1f2937;
  letter-spacing: -0.01em;
}

.modulistica-card__desc {
  margin: 0.2rem 0 0;
  font-size: 0.8rem;
  line-height: 1.35;
  color: #6b7280;
}

.modulistica-card__body {
  padding: 1rem 1.15rem 1.15rem;
}

.modulistica-label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #374151;
}

.modulistica-dropzone {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.45rem;
  min-height: 5.5rem;
  padding: 1rem;
  border: 1.5px dashed #cbd5e1;
  border-radius: 10px;
  background: #fff;
  color: #64748b;
  transition: border-color 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.modulistica-dropzone:hover {
  border-color: #f97316;
  background: #fff7ed;
  color: #9a3412;
}

.modulistica-dropzone.has-file {
  border-style: solid;
  border-color: #86efac;
  background: #f0fdf4;
  color: #166534;
}

.modulistica-dropzone .pi {
  font-size: 1.35rem;
}

.modulistica-dropzone__text {
  font-size: 0.8rem;
  text-align: center;
  word-break: break-all;
  max-width: 100%;
}

.modulistica-file-list {
  margin: 0.5rem 0 0;
  padding-left: 1.1rem;
  max-height: 6rem;
  overflow-y: auto;
  font-size: 0.75rem;
  color: #64748b;
}

.modulistica-file-list li {
  margin-bottom: 0.15rem;
  word-break: break-all;
}

.modulistica-list__header {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.75rem;
}

.modulistica-list__header h4 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 650;
  color: #1f2937;
}

.modulistica-list__count {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.5rem;
  height: 1.5rem;
  padding: 0 0.45rem;
  border-radius: 999px;
  background: #fff1e6;
  color: #c2410c;
  font-size: 0.75rem;
  font-weight: 700;
}

.modulistica-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 600;
  letter-spacing: 0.01em;
}

.modulistica-badge.is-admin {
  background: #f1f5f9;
  color: #475569;
}

.modulistica-badge.is-agente {
  background: #ecfdf5;
  color: #047857;
}

.modulistica-empty {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  padding: 1.5rem;
  border: 1px dashed #e5e7eb;
  border-radius: 10px;
  color: #9ca3af;
  font-size: 0.875rem;
  background: #fcfcfd;
}

.modulistica-empty .pi {
  font-size: 1.1rem;
}

.date_created_offerta {
  font-size: 9px;
  color: rgb(0, 0, 0) !important;
}

.lampadina {
  background-image: url(../../../../public/images/lampadina-bianca.svg);
  background-repeat: no-repeat;
}

.fiamma {
  background-image: url(../../../../public/images/fiamma-bianca.svg);
  background-repeat: no-repeat;
}

.font-unita {
  font-size: 1.3rem;
  font-weight: 400;
}

.font-device {
  font-size: 1.5rem;
  font-weight: 700;
}

.font-description {
  font-size: 1.5rem;
  font-weight: 600;
}

.font-description-large {
  font-size: 2rem;
  font-weight: 800;
}

.card-offerta {
  width: 300px;
  height: 60px;
  border: #4887c5 1px solid !important;
  border-radius: 10px;
}

.card-offerta label {
  word-wrap: break-word;
  hyphens: auto;
}

.bg-blue{
  color:#2563eb
}

.bg-red{
  color:crimson
}
</style>
